/**
 * @license
 * @qwik.dev/core 2.0.0-beta.42-dev+3473a49
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as We, isBrowser as Ve } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as De } from "@qwik.dev/core/preloader";

const Ue = !1;

const Be = (t, ...n) => He(!1, t, ...n);

const He = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const Qe = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const Je = (t, n, e, s, o = !1) => {
    const r = Qe(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Ye = (t, n, e) => {
    const s = Qe(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ge = (t, n, e) => Qe(t, n, e) >= 0;

const Ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ke = t => typeof t === "object" && t !== null;

const tr = t => Array.isArray(t);

const nr = t => typeof t === "string";

const er = t => typeof t === "function";

const rr = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = He(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const ir = "<sync>";

const sr = t => typeof t === "function" && typeof t.getSymbol === "function";

const Nd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const or = "q:type";

const lr = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const fr = 124;

const ar = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const hr = "q:renderFn";

const dr = "q:componentHash";

const pr = "q:targetEl";

const $r = "⚡️";

const yr = "q:slot";

const wr = "q:sparent";

const mr = "q:s";

const br = "[q\\:patch]";

const vr = "q:r";

const xd = "q:rp";

const _r = "q:ebc";

const gr = "q:style";

const Er = "style[q\\:style]";

const Sr = Er + ",style[q\\:sstyle]";

const kr = "q:sstyle";

const Rr = "q:ctx";

const Pr = "q:brefs";

const Tr = (t, n) => t["qFuncs_" + n] || [];

const Ar = "q:base";

const qr = "q:container-island";

const Mr = "/" + qr;

const Ir = "q:ignore";

const xr = "/" + Ir;

const Nr = "q:container";

const Cr = "/" + Nr;

const Or = "q:template";

const jr = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Lr = "http://www.w3.org/1999/xhtml";

const Fr = "http://www.w3.org/2000/svg";

const Xr = "http://www.w3.org/1998/Math/MathML";

const Dr = "qRender";

const Wr = "q:id";

const Vr = "q:key";

const Ur = "q:props";

const zr = "q:seq";

const Br = "q:seqIdx";

const Hr = "q:p";

const Qr = "q:ps";

const Yr = ":on";

const Gr = ":onIdx";

const Zr = ":onFlags";

const Kr = ":cursorBoundary";

const ti = ":nearestCursorBoundary";

const ni = ":";

const ei = "dangerouslySetInnerHTML";

const ii = 100;

const si = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const oi = (t, n, e) => {
    try {
        const s = t();
        return si(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const li = (t, n) => si(t) ? t.then(n) : n(t);

const ui = t => new Promise(n => {
    setTimeout(n, t);
});

const ci = t => {
    throw t;
};

function n(t, n = ci) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!si(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ii;
    const r = async e => {
        for (;si(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!si(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const fi = t => $r + t;

const ai = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + fi(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const hi = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + di(t.slice(s, -1));
        }
    }
    return null;
}

const di = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = pi(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const pi = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const $i = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const yi = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const wi = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const mi = t => {
    if (!t) {
        return "";
    }
    if (nr(t)) {
        return t.trim();
    }
    const n = [];
    if (tr(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = mi(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const bi = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const vi = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (tr(t)) {
            throw rr(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(bi(e) + ":" + _i(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = mi(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = vi(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const _i = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => yi.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const gi = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.$n = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Ei = () => ({
    isServer: We,
    importSymbol(t, n, e) {
        if (We) {
            const t = Nd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw rr(6, [ e ]);
        }
        if (!n) {
            throw rr(14, [ e ]);
        }
        if (!t) {
            throw rr(13, [ n, e ]);
        }
        const s = Si(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Si = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Ar) ?? s, s);
    return new URL(e, o);
};

let ki = /*#__PURE__ */ Ei();

const Ri = t => ki = t;

const Pi = () => ki;

const Cd = () => ki.isServer;

const Od = typeof document !== "undefined";

const Ti = !We && Od;

const Ai = Ti ? document : void 0;

const qi = Ti && Ai.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Mi = /\.[mc]?js$/;

const Ii = t => {
    let n = xi.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            yn: t,
            Gt: Mi.test(t) ? 0 : 3,
            wn: n,
            mn: 1,
            bn: performance.now(),
            vn: 0,
            _n: 0
        }))(t, e);
        xi.set(t, n);
    }
    return n;
};

const xi = new Map;

let Ni = 0;

const Ci = [];

const Oi = gi(function Ld() {
    Li = !1;
    if (!Ci.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;Ci.length; ) {
        const e = Ci[0];
        const s = e.mn;
        const o = 1 - s;
        if (!(o >= .99 || Ni < 25)) {
            break;
        }
        Ci.shift();
        Vi(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Ci.length && !Li) {
        Li = !0;
        Oi();
    }
});

const ji = gi(i);

let Li = !1;

let Fi = !1;

let Xi = !1;

const Di = [];

const Wi = () => {
    const t = Di[Di.length - 1];
    const n = t.gn;
    if (t.wn) {
        const e = t.Xt;
        if (e >= t.wn.length) {
            Di.pop();
            return !1;
        }
        const s = t.wn[e];
        t.Xt = e + 1;
        const o = Ii(s.yn);
        if (o.mn === 0) {
            return !0;
        }
        const r = 1 - n.mn;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.En);
        } else {
            const t = 1 - s.En * r;
            const n = s.Sn;
            const e = t / n;
            i = Math.max(.02, o.mn * e);
            s.Sn = e;
        }
        Di.push({
            gn: o,
            mn: i,
            kn: t.kn
        });
        return !0;
    }
    if (t.kn?.has(n)) {
        Di.pop();
        return !1;
    }
    const e = n.mn;
    n.mn = t.mn;
    if (e - n.mn < .01) {
        Di.pop();
        return !1;
    }
    if (n.wn?.length) {
        const e = t.kn || new Set;
        e.add(n);
        t.kn = e;
        t.wn = n.wn;
        t.Xt = 0;
        return !1;
    }
    Di.pop();
    return !1;
};

function i() {
    if (Xi || !Di.length) {
        return;
    }
    Fi = !1;
    Xi = !0;
    const t = Ti ? performance.now() + 10 : 0;
    let n = !1;
    for (;Di.length; ) {
        n = !0;
        const e = Wi();
        if (Ti && e && performance.now() >= t) {
            if (!Fi) {
                Fi = !0;
                ji();
            }
            break;
        }
    }
    Xi = !1;
    n && Ti && Oi();
}

const Vi = t => {
    if (t.Gt >= 2) {
        return;
    }
    Ni++;
    const n = performance.now();
    t.vn = n - t.bn;
    t.Gt = 2;
    const e = Ai.createElement("link");
    e.href = new URL("undefined" + t.yn, Ai.baseURI).toString();
    e.rel = qi;
    e.as = "script";
    e.onload = e.onerror = () => {
        Ni--;
        const s = performance.now();
        t._n = s - n;
        t.Gt = 4;
        e.remove();
        Oi();
    };
    Ai.head.appendChild(e);
};

const Ui = (t, n) => {
    const e = Ii(t);
    e && ((t, n) => {
        Di.unshift({
            gn: t,
            mn: n,
            kn: void 0
        });
    })(e, n);
};

Ti && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Ui(e, 0);
                }
            } else {
                Ui(t, 0);
            }
            Ti ? ji() : i();
        })(t);
    }
});

const zi = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Bi = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Hi = '"';

const Qi = "[";

const Ji = "]";

const Yi = ",";

const Gi = "2.0.0-beta.42-dev+3473a49";

const Zi = t => t.nodeType === 1;

const Ki = t => {
    const n = t.Rn;
    return n || t;
};

const jd = t => t.It;

const ts = Symbol();

class ns {
    [ts]=void 0;
}

const es = t => t === "foreignObject";

const rs = t => t === "svg" || es(t);

const is = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== ni && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const ss = {
    elementNamespace: Lr,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!ru(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && es(ru(t));
    let o = Lr;
    let r = 0;
    const i = typeof n === "string" || kl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return rs(t);
        }
        if (kl(t)) {
            return rs(ru(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Fr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return is(t);
        }
        if (kl(t)) {
            return is(ru(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Xr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Fr : e ? Xr : Lr;
        r = t.flags & 1536;
    }
    ss.elementNamespace = o;
    ss.elementNamespaceFlag = r;
    return ss;
}

class os {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [ts]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class ls extends os {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class us extends ls {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class cs extends os {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const fs = [];

const as = [];

function l(t, n) {
    const e = y(n).priority;
    let s = fs.length;
    for (let t = 0; t < fs.length; t++) {
        const n = y(fs[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    fs.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < fs.length; t++) {
        const n = fs[t];
        let e = !1;
        for (let t = 0; t < as.length; t++) {
            const s = as[t];
            if (ku(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    as.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = fs.indexOf(t);
    if (s !== -1) {
        fs.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = as.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = as.length - 1;
    e !== s && (as[e] = as[s]);
    as.pop();
    n.o--;
    return !0;
}

const hs = new WeakMap;

const ds = ":nodeProps";

const ps = ":nodeDiff";

const $s = ":errorData";

const ys = ":signal";

const ws = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && pn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return hs.get(t) ?? null;
}

const ms = Symbol();

const bs = Symbol();

const vs = Symbol();

const _s = Symbol();

const gs = Symbol();

const Es = Symbol();

const Ss = [];

const ks = {};

Object.freeze(Ss);

Object.freeze(ks);

function w(t) {
    return new Proxy({}, new Rs(t));
}

class Rs {
    owner;
    ht=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ms) {
            return this.owner.constProps;
        }
        if (n === bs) {
            return this.owner.varProps;
        }
        if (n === vs) {
            return this.owner;
        }
        if (n === _s) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = As(this.owner, n);
            n in this.owner.varProps && Ps(this, n);
        }
        return s instanceof so ? s.value : s;
    }
    set(t, n, s) {
        if (n === vs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ms) {
            this.owner.constProps = s;
        } else if (n === bs) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ks ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Ts(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Ts(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ms || n === bs) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Ps(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Ps = (t, n) => {
    const e = sa();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.hn;
    s && Nn(t.owner._proxy, n, t, s);
};

const Ts = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ht, n);
    e && Uu(t.$, t, e);
    return !!e;
};

const As = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const qs = (t, n) => Ms(t)?.[n] || Is(t)?.[n] || null;

const Ms = t => {
    if (!t) {
        return null;
    }
    return bs in t ? "children" in t ? {
        ...t[bs],
        children: t.children
    } : t[bs] : t;
};

const Is = t => {
    if (!t) {
        return null;
    }
    return ms in t ? t[ms] : null;
};

const xs = t => t && bs in t;

const Ns = Symbol();

class Cs {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Os = Symbol();

const js = Symbol();

const Ls = Symbol();

function m(t, n, e) {
    t[ts] || (We && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Pr, new Map) : t[ts] = new Map);
    const o = t[ts];
    let r = o.get(n);
    if (!r) {
        r = new Cs(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Fs = (t, n) => (e, s) => {
    const o = Fe();
    o.hn = m(t, ":");
    o.$ = n || void 0;
    return Oe(o, () => {
        if (er(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Fu(e)) {
            return e.value;
        }
        if (Ke(e) && nc(e)) {
            Nn(Gu(e), Ls, Yu(e), o.hn);
            return e;
        }
        throw rr(2);
    });
};

class Xs {
    Dt;
    ht=void 0;
    $=null;
    Pn=null;
    constructor(t, n) {
        this.$ = t || sa()?.$ || null;
        this.Dt = n;
    }
    trigger() {
        Uu(this.$, this, this.ht);
    }
    force() {
        Uu(this.$, this, this.ht);
    }
    get untrackedValue() {
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = sa();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.hn;
        if (e) {
            const t = We;
            const s = this.ht ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            Xu(s, e);
            Du(e, this);
            if (t) {
                const t = Vu(n.$, this.$);
                o && t?.Tn?.(this, e, null);
                Wu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Dt) {
            this.Dt = t;
            Uu(this.$, this, this.ht);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Dt
        };
    }
}

class Ds {
    An;
    qn=null;
    Mn=!1;
    In=!0;
    constructor(t, n, e) {
        this.An = t;
        if (n !== void 0) {
            this.info = n;
            this.xn = e;
        }
    }
    get track() {
        return this.Nn ||= Fs(this.An, this.An.$);
    }
    get abortSignal() {
        return (this.Cn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.An.Dt;
        if (t !== Ns) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.On ||= []).push(t);
    }
}

class Ws extends Xs {
    Wt;
    h;
    [ts]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || sa()?.$, Ns);
        this.Wt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Dt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.zt = r;
            this.Bt = [];
        }
        s.timeout && (this.Ht = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Dt = Ns;
        this.invalidate();
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.jn = t;
            this.xn = this.xn === void 0 ? 1 : this.xn + 1;
        }
        if (this.h & 512) {
            this.Ln(!0);
            return;
        }
        this.h |= 1;
        const e = Fe();
        e.$ = this.$ || void 0;
        const s = n(je.bind(this, e, this.p));
        si(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.jn = void 0;
            if (this.Bt) {
                for (let t = 0; t < this.Bt.length; t++) {
                    this.Bt[t].In = !1;
                }
            } else {
                this.lt && (this.lt.In = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.lt?.qn) {
            if (this.Dt === Ns || We) {
                throw this.lt?.qn;
            }
            return this.Dt;
        }
        if (this.Vt) {
            throw this.Vt;
        }
        if (We && this.h & 64 && this.Dt === Ns) {
            throw rr(35);
        }
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = sa();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                Xu(this.wt ||= new Set, t);
                Du(t, this);
                Wu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Ut) {
            this.Ut = t;
            Uu(this.$, this, this.wt);
        }
    }
    get untrackedPending() {
        this.p();
        if (We && this.lt?.qn) {
            throw this.lt?.qn;
        }
        return !!this.Ut;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = sa();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                Xu(this.bt ||= new Set, t);
                Du(t, this);
                Wu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Vt) {
            this.Vt = t;
            Uu(this.$, this, this.bt);
        }
    }
    get untrackedError() {
        this.p();
        if (We && this.lt?.qn) {
            throw this.lt?.qn;
        }
        return this.Vt;
    }
    Ln(t) {
        this.h |= 1;
        t && (this.ht?.size || this.wt?.size || this.bt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.lt && this.Fn(this.lt, t);
    }
    vt() {
        if (!(this.h & 32) || this.Xn()) {
            return;
        }
        if (!Ve) {
            return;
        }
        setTimeout(() => {
            this.Xn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.lt?.qn; ) {
            await (this.lt?.qn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Dn();
        }
        const t = this.Wt;
        Lu(t);
        const e = this.lt;
        if (e && !e.Mn) {
            e.Mn = !0;
            e.Cn?.abort();
            this.Wn(e);
        }
        const s = new Ds(this, this.jn, this.xn);
        this.lt = s;
        let o;
        try {
            o = this.Vn(t.resolved, s);
        } catch (t) {
            if (si(t)) {
                throw t;
            }
            s.xn === this.xn && (this.jn = void 0);
            this.h &= -2;
            this.Un(s, t);
            return;
        }
        if (si(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.Vn(this.Wt.resolved, s);
                t = void 0;
                return n;
            };
            s.qn = this.zn(s, () => n(e));
            return;
        }
        s.xn === this.xn && (this.jn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    Vn(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = sa();
            t?.hn && (t = {
                ...t,
                hn: void 0
            });
            return je(t, e, [ n ]);
        }
        const s = this.$ ||= sa()?.$ || null;
        const o = m(this, ".");
        s && Pn(s, o);
        const r = Fe();
        r.$ = s || void 0;
        r.hn = o;
        return je(r, e, [ n ]);
    }
    Dn() {
        if (We && this.h & 64) {
            this.Ut = !0;
            this.$?.serializationCtx.Ce.add(this);
            return;
        }
        this.h &= -2;
        const t = this.lt;
        t && this.Fn(t);
        const n = this.zt === 0 ? Infinity : this.zt ?? 1;
        if (this.Bt ? this.Bt.length >= n : t?.qn) {
            this.h |= 1;
            return;
        }
        const e = this.xn;
        const s = new Ds(this, this.jn, e);
        this.lt = s;
        this.Bt && this.Bt.push(s);
        s.qn = this.Bn(s);
    }
    async Bn(t) {
        let e = this.Wt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Wt.resolve();
            if (t.Cn?.signal.aborted) {
                t.qn = null;
                return;
            }
        }
        this.Ht && (this.Hn = setTimeout(() => {
            const n = Error(`timeout ${this.Ht}ms`);
            this.Un(t, n);
            t.Cn?.abort(n);
        }, this.Ht));
        return this.zn(t, () => n(() => this.Vn(e, t)));
    }
    async zn(t, n) {
        try {
            const e = n();
            let s;
            if (si(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.qn = null;
            if (t.In) {
                const n = this.Bt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].In = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.qn = null;
            this.Un(t, n);
        }
        if ((() => t === this.lt)()) {
            clearTimeout(this.Hn);
            t.xn === this.xn && (this.jn = void 0);
            this.h & 1 ? this.p() : this.untrackedPending = !1;
        }
    }
    Un(t, n) {
        if (t !== this.lt || !t.In) {
            return;
        }
        t.In = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Ns;
    }
    async $n() {
        clearTimeout(this.Hn);
        const t = this.lt;
        t && this.Fn(t);
        this.Bt ? await Promise.all(this.Bt.map(t => t.qn)) : await (t?.qn);
    }
    Xn() {
        return !!(this.ht?.size || this.wt?.size || this.bt?.size);
    }
    Fn(t, n) {
        if (t.Mn) {
            return;
        }
        t.Mn = !0;
        t.Cn?.abort(n);
        t.qn = li(t.qn, () => this.Qn(t));
    }
    Wn(t) {
        const n = t.On;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    si(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Qn(t) {
        const n = () => {
            t.qn = null;
            const n = this.Bt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Wn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const Vs = t => (n, ...e) => t.call(null, Da(n), ...e);

class Us extends Ws {
    constructor(t, n) {
        super(t, n, 17);
    }
    Jn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Lu(this.Wt);
        const t = ca(this.Wt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Dt === Ns ? e : this.Dt;
        const r = aa(() => this.Jn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Jn = !0;
        this.h &= -2;
        const i = this.Jn && r !== "undefined" || r !== this.Dt;
        if (i) {
            this.Dt = r;
            Uu(this.$, this, this.ht);
        }
    }
}

class zs extends Ws {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Bs = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Hs = (t, n) => new Ws(n?.container || null, t, Bu(n?.serializationStrategy || "always"), n);

const Qs = (t, n) => new zs(n?.container || null, t, Bu(n?.serializationStrategy || "always"), n);

const Js = t => new Us(null, t);

const Ys = t => new Xs(null, t);

const Gs = /*#__PURE__*/ Vs(Hs);

const Zs = Vs(Js);

const Ks = t => t.value;

const to = (t, n) => t[n];

const no = t => {
    if (t.length === 1) {
        if (Fu(t[0])) {
            return t[0].Pn ||= new so(null, Ks, t, null);
        }
        if (nc(t[0])) {
            return new so(null, Ks, t, null);
        }
        return t[0].value;
    }
    return new so(null, to, t, null);
};

const eo = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ke(n)) {
        return n[e];
    }
    if (Fu(n)) {
        if (n instanceof so) {
            return n;
        }
        return no(t);
    }
    if (xs(n)) {
        const s = n[ms];
        const o = n[bs];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return ro(n, t);
        }
    } else {
        const s = Gu(n);
        if (s) {
            const n = s[e];
            return ro(n, t);
        }
    }
    return n[e];
};

const ro = (t, n) => Fu(t) ? t : no(n);

const io = (t, n) => {
    const e = eo(t, n);
    if (e === gs) {
        return t[n];
    }
    return e;
};

class so extends Xs {
    ct;
    ut;
    Pt;
    h;
    _=void 0;
    [ts]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, Ns);
        this.ct = e;
        this.ut = n;
        this.Pt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, ys, this);
                wn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Uu(this.$, this, this.ht);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Dt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = aa(() => this.ut(...this.ct), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Dt;
        if (n) {
            this.h |= 2;
            this.Dt = t;
        }
    }
    st() {
        return this.ut === Ks && Fu(this.ct[0]) ? this.ct[0] : this;
    }
    set value(t) {
        throw rr(31);
    }
    get value() {
        return super.value;
    }
}

class oo {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class lo {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || zi(n) ? ks : n;
        this.constProps = !e || zi(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const uo = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const co = t => t instanceof lo;

const fo = (t, n, e) => {
    if (typeof t === "string") {
        const s = qe(n);
        return na(s, () => {
            Ta(Aa(s, t));
            return e();
        });
    }
    return e();
};

function b(t, n) {
    return fo(this, n, () => {
        const t = Pa[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function v(t, n) {
    return fo(this, n, () => {
        const t = Pa[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return fo(this, n, () => {
        if (Pa) {
            for (let t = 0; t < Pa.length; t++) {
                const n = Pa[t];
                n instanceof zs && n.h & 64 && n.p();
            }
        }
    });
}

const ao = "bind:value";

const ho = "bind:checked";

const po = "passive:";

const $o = "preventdefault:";

const yo = Object.prototype.hasOwnProperty;

const wo = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(di(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const mo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return di(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return di(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return di(t.slice(11, -1));
    }
    return null;
};

const bo = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = mo(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const vo = (t, n, e, s, o, r, i) => new lo(t, n, e, s, o, r, !1, i);

const _o = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(po)) {
                    r.push(o);
                    t.add(di(o.slice(8)));
                } else {
                    o.startsWith($o) ? h.push(o) : mo(o) !== null ? s.push(o) : o === ho ? a = e[o] : o === ao && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(po)) {
                    i.push(s);
                    t.add(di(s.slice(8)));
                } else {
                    s.startsWith($o) ? d.push(s) : mo(s) !== null ? o.push(s) : s === ho ? a = n[s] : s === ao && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = wo(e, r, h, t, l);
            l = l || e !== n;
            e = bo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = wo(n, i, d, t, u);
            u = u || n !== e;
            n = bo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && yo.call(n, ho) && delete n[ho];
                if (e && yo.call(e, ho)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ho];
                }
                n.checked = a;
                const t = xa(null, "_chk", v, null, [ a ]);
                if (e && yo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = uo(n, "q-e:input", t) || c;
                }
                c = uo(n, "q-e:input", t) || c;
            } else if (f) {
                n && yo.call(n, ao) && delete n[ao];
                if (e && yo.call(e, ao)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ao];
                }
                n.value = f;
                const t = xa(null, "_val", b, null, [ f ]);
                if (e && yo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = uo(n, "q-e:input", t) || c;
                }
                c = uo(n, "q-e:input", t) || c;
            }
        }
        if (n && yo.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && yo.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new lo(t, n, e, s, o, r, c || !0, i);
};

const go = (t, n, e, s) => Ro(t, n, s);

const Eo = (t, n, e, s, o) => Ro(t, {
    ...e,
    ...n
}, o);

const So = (t, n, e, s, o, r) => Ro(t, {
    ...e,
    ...n,
    children: s
}, r);

const ko = t => t.children;

const Ro = (t, n, e, s, o) => _o(t, n, null, null, 0, e, o);

const Po = Ro;

const To = Ro;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return _o(t, n, null, s.children, 0, o);
}

const Ao = t => t.children;

const qo = (t, n) => new lo(ko, null, null, t.children, 0, n);

const Mo = t => vo(ko, null, {
    [mr]: ""
}, t.children, 0, t.name ?? "");

const Io = Symbol();

const xo = () => null;

const No = () => null;

const Co = t => t.children;

const Oo = (t, n) => Ro(qo, {
    children: Ro(jo, t)
}, n);

const jo = () => null;

let Lo = null;

let Fo = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Fo || (Fo = t.setAttributeNS);
                    Fo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Lo || (Lo = t.setAttribute);
            Lo.call(t, n, e);
        })(t, n, e);
    }
}

const Xo = Object.prototype.hasOwnProperty;

const Do = Object.prototype.propertyIsEnumerable;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const Wo = (t, n = [], e = {}) => {
    if (!Ke(t) || !xs(t)) {
        if (t == null) {
            throw new TypeError(`Cannot destructure '${t}' as it is ${t}.`);
        }
        const s = Object(t);
        const o = Reflect.ownKeys(s);
        for (let t = 0; t < o.length; t++) {
            const r = o[t];
            !Do.call(s, r) || typeof r !== "symbol" && n.includes(r) || Object.defineProperty(e, r, {
                value: s[r],
                enumerable: !0,
                configurable: !0,
                writable: !0
            });
        }
        return e;
    }
    let s = null;
    const o = t[ms];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[bs];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new lo(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Xo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof so) {
            return ha(n, t, ":", e);
        }
    }
    return As(n, "name") || "";
}

class Vo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Uo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class zo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Bo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Ho {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Qo = t => new Vo(t);

const Jo = t => new Uo(t);

const Yo = (t, n) => new zo(t, n);

const Go = (t, n, e) => new Bo(t, n, e);

const Zo = (t, n, e, s = null, o = !1) => new Ho(t, n, e, s, o);

const Ko = () => {
    const t = la();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, zr);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, zr, s);
    }
    let o = t.$.getHostProp(e, Br);
    o === null && (o = 0);
    t.$.setHostProp(e, Br, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const tl = t => {
    const n = er(t) && !Ha(t) ? Oe(void 0, t) : t;
    return Ys(n);
};

const nl = t => el(tl, t);

const el = (t, ...n) => {
    const {val: e, set: s} = Ko();
    if (e != null) {
        return e;
    }
    t = er(t) && !Ha(t) ? ca(t, ...n) : t;
    return s(t);
};

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = q(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return Ml(t, Kr, null) || null;
}

function A(t) {
    M(t, null);
}

function q(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return Ml(t, ti, null) || T(t);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && Il(t, ti, n);
}

function I(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        I(s, T(s) || n);
    }
}

const rl = t => {
    if (t.$n) {
        try {
            t.$n();
        } catch (t) {
            Be(t);
        }
        t.$n = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = qe(s);
        return na(n, () => x(t, e, s, ua(e, s, n)));
    }
    const r = o.$;
    const i = o._;
    Cl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r.k : null;
        const l = Ml(i, Hr, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Ml(i, Qr, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return je(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function N(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = qe(n);
    return na(e, () => {
        const s = ua(t, n, e);
        typeof this === "string" && Ta(Aa(s.$, this));
        const o = Pa[0];
        return x(o, t, n, s);
    });
}

function C(t) {
    return t.R === t.T ? t.q : null;
}

function O(t) {
    return t.M || C(t);
}

function j(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = C(t);
    return e === o ? null : e;
}

const il = Object.prototype.hasOwnProperty;

function L(t, n, e, s, o, r) {
    Il(n, e, r);
    mn(t, Zo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function F(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        X: [],
        D: [],
        R: null,
        M: null,
        W: null,
        q: null,
        T: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        Z: 0,
        K: !0,
        tt: !1,
        nt: {
            et: new oo({
                j: s,
                rt: !0
            }),
            it: new oo({
                j: s,
                rt: !1
            })
        }
    };
}

function X(t, n, e, s, o) {
    const r = t ?? F(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.it.data.j = o;
        t.X.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const sl = (t, n, e, s, o, r, i) => D(X(i, t, n, o, r), e, s);

const ol = (t, n, e, s, o, r, i, c, l = !1, u) => D(X(u, t, n, i, c), e, s, o, r, l);

function D(t, n, e, s = ou(e), o = null, r = !1) {
    W(t, n, e, s, o, r);
    const i = Z(t);
    if (si(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function W(t, n, e, s = ou(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.R = e;
    t.W = null;
    t.M = s;
    t.q = o;
    t.T = e;
    H(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.Z; ) {
                if (typeof t.Y === "string") {
                    mt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    mt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (co(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            et(t);
                            ft(t, t.Y, n);
                            const e = t.Y.constProps && il.call(t.Y.constProps, ei) || il.call(t.Y.varProps, ei);
                            e ? t.W || tt(t, !1) : z(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Ao) {
                                et(t);
                                pt(t, "F", t.Y.key);
                                z(t, t.Y.children, !0);
                            } else if (n === Mo) {
                                et(t);
                                Y(t) || z(t, t.Y.children, !0);
                            } else if (n === _t) {
                                J(t);
                                z(t, t.Y.children, !0, !0);
                            } else if (n === No) {
                                nt(t);
                            } else if (n === xo) {
                                nt(t);
                            } else {
                                et(t);
                                $t(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        z(t, t.Y, !1);
                    } else if (Fu(t.Y)) {
                        pt(t, "S", null);
                        const n = t.Y instanceof so ? t.Y.st() : t.Y;
                        const e = t.M?.[ts]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof so && (s = xt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            z(t, V(t, () => ha(n, e, ".", t.$)), !0);
                        }
                    } else if (si(t.Y)) {
                        pt(t, "A", null);
                        t.X.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === Io || mt(t, "");
                }
                U(t);
            }
            nt(t);
            G(t);
            B(t);
        }
    } finally {
        t.tt = i;
    }
}

function V(t, e) {
    try {
        return e();
    } catch (s) {
        if (si(s)) {
            const o = s.then(() => n(e));
            t.X.push(o, t.W || t.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.G++;
    if (t.G < t.Z) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return B(t);
    }
    t.W !== null ? t.W = null : t.M = j(t, t.M);
}

function z(t, n, e, s = !1) {
    if (!s && (n == null || e && tr(n) && n.length === 0)) {
        tt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !ou(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = ou(t.R);
        t.W = null;
    }
    t.K = !1;
}

function B(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.Z = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    U(t);
}

function H(t, n, e) {
    t.L.push(t.J, t.G, t.Z, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.Z = n.length;
        t.J = n;
        t.Y = t.Z > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.Z = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.Z = 1;
    }
}

function Q(t) {
    if (t.W) {
        return O(t);
    }
    return j(t, t.M) || C(t);
}

function J(t) {
    const n = t.Y;
    const e = n.key;
    t.M = Ml(t.R, e, n => Fl(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = El();
        Il(t.W, yr, e);
        t.W.slotParent = t.R;
        Il(t.R, e, t.W);
    }
}

function Y(t) {
    const n = t.Y;
    const e = xu(t.R);
    const s = R(e, n, t.$);
    const o = As(n, Kr) || null;
    const r = e ? Ml(e, s, null) : null;
    if (r == null) {
        t.W = El();
        Il(t.W, yr, s);
        Il(t.W, Kr, o);
        I(t.W, o);
        e && Il(e, s, t.W);
        Zl(t.N, t.R, t.W, Q(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.W = r;
        Il(t.W, yr, s);
        Il(t.W, Kr, o);
        I(t.W, o);
        e && Il(e, s, t.W);
        Gl(t.N, t.W);
        Zl(t.N, t.R, t.W, Q(t));
        n && kl(n) && !n.firstChild && ru(n) === Or && nu(t.N, n.parent, n, !0);
    }
    return !0;
}

function G(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            St(t.$, t.N, e, t.O);
            nu(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function Z(t) {
    for (;t.X.length; ) {
        const n = t.X.shift();
        const e = t.X.shift();
        if (si(n)) {
            return n.then(n => {
                W(t, n, e);
                return Z(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return Z(t);
            });
        }
        W(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => Z(t));
    }
}

function K(t) {
    t.N = null;
    t.O = null;
}

function tt(t, n = !0) {
    const e = t.M && ou(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            St(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        eu(t.N, t.M, e, n);
    }
}

function nt(t) {
    const n = C(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = j(t, t.M);
            if (t.R === n.parent) {
                St(t.$, t.N, n, t.O);
                nu(t.N, t.R, n, !0);
            }
        }
    }
}

function et(t) {
    if (t.M !== null && Tl(t.M)) {
        const n = t.M;
        t.M = j(t, t.M);
        nu(t.N, t.R, n, !0);
    }
}

function rt(t, n, e) {
    if (Fu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw rr(15, [ e ]);
}

function it(t, e, s, o, r) {
    return n(() => ha(o, e, s, t, r));
}

function st(t, n, e, s, o) {
    const i = t.j;
    const c = s.then(t => E(n, e, r(e, t, i), o));
    t.D.push(c);
}

function ot(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Nr, "html");
    }
}

function lt(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ut(t, n, e, s) {
    const i = function c(t, n) {
        const e = tu(t.R, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.W = vl(i, n);
        t.W.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.W;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (hi(n)) {
                ct(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && rt(o, i, s)) {
                continue;
            }
            Fu(o) && (o = it(t.$, t.W, n, o, t.nt.et));
            if (si(o)) {
                st(t, i, n, o, u);
                continue;
            }
            if (n === ei) {
                ot(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && lt(i, o)) {
                continue;
            }
            E(i, n, r(n, o, t.j), u);
        }
    }
    const a = n.key;
    a && (t.W.key = a);
    if (t.j) {
        const e = il.call(n.varProps, "class") || n.constProps && il.call(n.constProps, "class");
        e || i.setAttribute("class", t.j);
    }
    Bl(t.N, t.R, t.W, O(t));
}

function ct(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && xl(o.N, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ft(t, n, e) {
    if (t.tt) {
        ut(t, n, e, null);
    } else {
        const s = t.M && kl(t.M);
        const o = s && e === ru(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            ht(t, e, r);
        } else {
            const s = at(e, r);
            dt(t, e, r, s, t.R) && ut(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function r(t, n, e, s) {
        t.tt || Cl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !il.call(o, i) ? i.toLowerCase() : i;
            if (o && il.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    Il(n, l, null);
                    Il(n, i, e);
                }
                Tt(c, e) || ll(t, n, i, c, s);
            } else {
                c != null && ll(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                il.call(e, r) || r.charAt(0) === ":" || hi(r) || ll(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const ll = (t, n, e, s, o) => {
    if (hi(e)) {
        ct(e, s, n.node, n, t);
        return;
    }
    if (e === Hr || e === Qr) {
        Il(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (rt(s, t, o)) {
            return;
        }
    }
    const i = n[ts]?.get(e);
    if (Fu(s)) {
        const o = s instanceof so ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Pn(t.$, i);
        const r = n;
        s = it(t.$, r, e, o, t.nt.it);
    } else {
        i && Pn(t.$, i);
    }
    if (si(s)) {
        const o = n;
        const i = s.then(n => {
            L(t.N, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    L(t.N, n, e, s, t.j, r);
};

function at(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function ht(t, n, e) {
    const s = at(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function dt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = kl(o) ? ru(o) : null;
                const r = bt(o) || vt(o, t.$.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const r = C(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = kl(i) ? ru(i) : null;
                const r = bt(i) || vt(i, t.$.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.U.set(at(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = at(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = kl(t.M) ? ru(t.M) : null;
                    const e = bt(t.M) || vt(t.M, t.$.k);
                    if (e != null) {
                        const s = at(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = C(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = kl(s) ? ru(s) : null;
                const e = bt(s) || vt(s, t.$.k);
                if (e != null) {
                    const o = at(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Zl(t.N, o, t.W, O(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = bt(t.M) || vt(t.M, t.$.k);
                if (n != null) {
                    const e = kl(t.M) ? ru(t.M) : null;
                    const s = at(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && Zl(t.N, o, n, O(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function pt(t, n, e) {
    const s = n === "F";
    const o = bt(t.M);
    const r = t.M && Al(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        ht(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Hl(t.N, t.R, t.W = El(), Q(t));
        t.W.key = e;
        return;
    }
    if (dt(t, null, e, at(null, e), t.R, !0)) {
        Hl(t.N, t.R, t.W = El(), Q(t));
        t.W.key = e;
    }
}

function $t(t, n) {
    const e = n[Ba];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = vt(s, t.$.k);
        const u = o.key || c;
        const f = bt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                ht(t, null, u);
            } else {
                yt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (dt(t, null, u, u, t.R)) {
                yt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = Ml(s, Ur, t.$.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = gt(n[ms], e[ms], e[_s], s, !1);
                        o ||= t;
                        const r = gt(n[bs], e[bs], e[_s], s, !0);
                        o ||= r;
                        e[vs] = n[vs];
                    } else if (n) {
                        Il(t, Ur, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    yt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Il(s, hr, i);
                s.flags &= -33;
                wn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new lo(_t, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            Je(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (co(n) && As(n, yr) || "") + "";
                const i = Qe(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            z(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = bt(s);
        const i = e === r;
        const c = vt(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            wt(t);
            s = t.W;
        } else if (i) {
            ht(t, null, e);
        } else {
            dt(t, null, e, e, t.R) && wt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!Al(e) || Ml(e, hr, null) === null); ) {
                e = e.parent || xu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[ws] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            wn(t.$, s, 8, t.O);
        }
    }
}

function yt(t, n, e, s) {
    n && Rn(t.$, n);
    Hl(t.N, t.R, t.W = El(), Q(t));
    const o = t.Y;
    Il(t.W, hr, e);
    Il(t.W, Ur, s);
    t.W.key = o.key;
}

function wt(t) {
    Hl(t.N, t.R, t.W = El(), Q(t));
    const n = t.Y;
    Il(t.W, Ur, n.props);
    n.key && (t.W.key = n.key);
}

function mt(t, n) {
    if (t.M !== null) {
        const e = Mu(t.M);
        if (e === 3) {
            if (n !== iu(t.M)) {
                su(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Bl(t.N, t.R, t.W = gl(document.createTextNode(n), n), O(t));
}

function bt(t) {
    if (t == null || Tl(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || Tl(t)) {
        return null;
    }
    const e = Ml(t, hr, n);
    return e ? e.ot : Ml(t, dr, null);
}

function _t() {}

function gt(t, n, e, s, o = !0) {
    if (Et(t) && Et(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Pr) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Tt(i, c) && !At(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = Ts(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Pr) {
                continue;
            }
            if ((!t || !il.call(t, s)) && o) {
                delete n[s];
                const t = Ts(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function Et(t) {
    if (!t) {
        return !0;
    }
    return zi(t);
}

function St(t, n, e, s = null) {
    let o = e;
    const r = s && pn(s) ? y(s) : null;
    if (Tl(e)) {
        Pt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && pn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            Rn(t, o);
            Pt(o);
            const r = c & 2 && Ml(o, hr, null) !== null;
            if (r) {
                const e = t.getHostProp(o, zr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ke(r)) {
                            const n = ju(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                wn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Ws || r instanceof so) && (r.h & 4 || Rn(t, r));
                            (n || r instanceof Ws && (r.h & 512 || r.lt)) && rl(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Fl(t.rootVNode, e) : e;
                                let c = ou(o);
                                for (;c; ) {
                                    St(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Rt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = ql(o);
            if (i) {
                if (o === e) {
                    const n = ou(o);
                    if (n) {
                        _n(n);
                        return;
                    }
                    kt(t, o);
                }
            } else {
                const t = ou(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Pt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function kt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, yr);
    e != null && t.getHostProp(n.slotParent, e) === n && Il(n.slotParent, e, null);
}

function Rt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && ru(s) === Or) {
            kt(t, e);
            nu(n, s, e, !0);
        }
    }
}

function Pt(t) {
    t.flags |= 32;
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof so && n instanceof so && It(n, t);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    if (Fu(t) && Fu(n)) {
        const e = t instanceof so ? t.st() : t;
        const s = n instanceof so ? n.st() : n;
        return ca(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return vi(t) === vi(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return mi(t) === mi(n);
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ut === t.ut && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ct, t.ct);
}

function xt(t, n) {
    if (!(n instanceof so)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof so && It(s, n)) {
            return !0;
        }
    }
    return !1;
}

const ul = (t, n, e, s, o) => {
    const r = Le(t.fn, n, t);
    if (e) {
        r.hn = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, hr));
    if (sr(s)) {
        o = o || t.getHostProp(n, Ur) || ks;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Ha(s)) {
        const t = s;
        i = () => je(r, t, [ o || ks, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => je(r, t, [ o || ks ]);
    }
    const l = We;
    const u = (e = 0) => oi(() => {
        if (!c) {
            t.setHostProp(n, Br, null);
            t.setHostProp(n, Gr, null);
        }
        e > 0 && Sl(n) && Rn(t, n);
        return li(i(o), t => li(r.dn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ii) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Yr);
        if (o) {
            return function r(t, n, e) {
                const s = jt(n);
                let o = n;
                const r = "q-e:qvisible";
                return li(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Ft();
                                    const n = We;
                                    n && t.ft(i) || (o = Lt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Ct(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (si(t) && e < ii) {
            return t.then(() => u(++e));
        }
        if (e >= ii) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ct(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = $i(n);
    c && Ot(t, f, "capture");
    l && Ot(t, f, "preventdefault");
    u && Ot(t, f, "stoppropagation");
}

function Ot(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ks && (t.varProps = {});
    t.varProps[s] = !0;
}

function jt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (co(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (tr(t)) {
            n.push(...t);
        } else {
            if (si(t)) {
                return li(t, t => jt(t));
            }
            if (Fu(t)) {
                return jt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Lt(t, n) {
    if (co(t)) {
        if (t.type !== Ao) {
            return vo(Ao, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : tr(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return vo(Ao, null, null, [ t, n ], 0, null);
    }
    if (tr(t) && t.length > 0) {
        Lt(t[0], n);
        return t;
    }
    return t;
}

function Ft() {
    return new lo("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Xt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Xt(t[c], c, r, s);
    }
    return i;
}

function Wt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Vt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = ou(e);
    const f = F(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return ol(c, n, Dt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        eu(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return ol(c, n, Dt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        eu(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            nu(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return ol(c, n, Dt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            nu(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let I = d;
    let A = w;
    const M = () => {
        for (;I >= h; ) {
            const t = I - h;
            if (P[t] === 1) {
                A = g[S[t]];
                I--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Zl(n, e, t, A);
                A = t;
                I--;
                continue;
            }
            let l = I;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = I - l + 1;
            const d = ol(c, n, Dt(o, a, null, i, l, I), e, A, A, s, null, !0, f);
            return li(d, () => {
                const t = Wt(e, A, u);
                A = t;
                I = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, zr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Ou) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Cu(s, n, t);
                si(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function zt(t, n) {
    const e = t.props ||= {};
    e[ps] = n;
}

function Bt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[$s] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[$s] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Ul(n, document, r, e);
    const u = kl(r) && i || r;
    const f = u === r ? null : c;
    Bl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Ht(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[ps];
    }(t);
    if (!r) {
        return;
    }
    zt(t, null);
    Fu(r) && (r = r.value);
    return sl(n, e, r, o, s, null);
}

function Qt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, hr);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Ur) || null;
    return Yt(n, o, o, r, i, e, s);
}

function Jt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[ws] || null;
        e && delete n[ws];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Yt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Yt(t, e, s, o, r, i, c) {
    const l = oi(() => ul(t, e, s, o, r), s => {
        const o = t.getHostProp(e, kr);
        return n(() => sl(t, i, s, e, c, ai(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (si(l)) {
        return l;
    }
    return;
}

function Gt(t, n, e, s, o, r = null) {
    n.push(Zo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Zt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[ds] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Fu(e) && (e = e.value);
        const r = s.isConst;
        Gt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[ds];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, zr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Ou && n.h & 16) {
            n.h &= -17;
            const t = n;
            rl(t);
        }
    }
}

function tn(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, ys);
    if (!s) {
        return;
    }
    const o = s.ht;
    const r = Fe();
    r.$ = e;
    return li(n(() => Oe.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Uu(e, s, o);
        }
    });
}

function nn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, Ur) || null;
    if (!r) {
        return;
    }
    let i = qs(r, "items");
    Fu(i) && (i = ca(i));
    const c = qs(r, "key$");
    const l = qs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Vt(n, e, o, s, i, u, f);
    }
    return li(c.resolve(), t => li(l.resolve(), r => Vt(n, e, o, s, i, t, r)));
}

let cl = null;

const fl = (t, n, e) => {
    cl || (cl = t.insertBefore);
    cl.call(t, n, e);
};

function en(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                fl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                fl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Bo) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            fl(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Vo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Uo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof zo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Ho) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (al(t, e)) {
                t[e] = hl(o);
            } else if (e === ei) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(Nr, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const al = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const hl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const dl = (t => () => queueMicrotask(t))(on);

const $l = gi(on);

let yl = !1;

function rn() {
    if (!yl) {
        yl = !0;
        dl();
    }
}

function sn() {
    if (!yl) {
        yl = !0;
        $l();
    }
}

function on() {
    yl = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (ln(e, n)) {
            sn();
            return;
        }
    }
}

function ln(t, n) {
    const e = We;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        un(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && A(l);
            p(r, s, an(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = fn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, an(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ut(l, r, s);
            } else if (l.dirty & 2) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Jt(l, r, i, t);
            } else if (l.dirty & 256) {
                e = nn(l, r, i, t);
            } else if (l.dirty & 16) {
                Zt(l, i);
            } else if (l.dirty & 32) {
                e = tn(l, r);
            } else if (l.dirty & 64) {
                const n = fn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && Bt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && si(e)) {
            P(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                rn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    un(r, t, s, e);
}

function un(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                en(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Cu(s, t, s.dt);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.suspense && t.props && Kr in t.props && Il(t, Kr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                cn(t);
            });
            return;
        }
        cn(t);
    }
}

function cn(t) {
    t.$t();
}

function fn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        A(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = an(o[0], s, t);
    p(t, n, i);
    return i;
}

function an(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && hn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && A(s);
    return an(s, n, e);
}

function hn(t, n) {
    if (!T(n)) {
        return !1;
    }
    pn(n) || dn(t, n, 0);
    return !0;
}

function dn(t, n, e) {
    if (pn(n)) {
        rn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        hs.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    rn();
    return r;
}

function pn(t) {
    return (t.flags & 256) !== 0;
}

function $n(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(ds);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Fu(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 32 && tn(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(zr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Ou) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Cu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        si(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Ur) || null;
            if (!s) {
                return;
            }
            let o = qs(s, "items");
            Fu(o) && (o = ca(o));
            const r = await qs(s, "key$").resolve();
            const i = await qs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const wl = [];

function yn(t) {
    for (let n = 0; n < wl.length; n++) {
        const e = wl[n];
        const s = wl[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function wn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return We;
    }()) {
        const e = $n(t, n);
        si(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            wl.push(n);
            let s = T(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = pn(o);
                __EXPERIMENTAL__.suspense && (s ||= T(o) || (t ? q(o) : null));
                if (o === e || t) {
                    M(n, s);
                    yn(o);
                    if (r) {
                        const t = y(o);
                        t.position !== o && (t.position = n);
                    }
                    wl.length = 0;
                    return;
                }
                if (r) {
                    const t = y(o);
                    t.position !== o && (t.position = n);
                }
                wl.push(o);
                o = o.slotParent || o.parent;
            }
            wl.length = 0;
            ((t, ...n) => {
                const e = He(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, T(n) || q(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (pn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        pn(n) ? M(n, T(n)) : function l(t) {
            wl.push(t);
            let n = T(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = pn(e);
                __EXPERIMENTAL__.suspense && (n ||= T(e) || (s ? q(e) : null));
                if (s) {
                    M(t, n);
                    yn(e);
                    wl.length = 0;
                    return !0;
                }
                wl.push(e);
                e = e.slotParent || e.parent;
            }
            M(t, n);
            wl.length = 0;
            return !1;
        }(n) || dn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const ml = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const bl = t => {
    let n = null;
    return e => {
        n || (n = ml(e, t));
        return n.call(e);
    };
};

const vl = (t, n, e = null) => {
    const s = new us(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const _l = t => {
    const n = new us(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const gl = (t, n) => {
    const e = new cs(-4084, null, null, null, null, t, n);
    return e;
};

const El = () => {
    const t = new ls(null, -4094, null, null, null, null, null, null);
    return t;
};

const Sl = t => t instanceof os;

const kl = t => (t.flags & 1) === 1;

const Rl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Pl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Tl = t => (t.flags & 4) === 4;

const Al = t => (t.flags & 2) === 2;

const ql = t => {
    const n = t.flags;
    return (n & 2) === 2 && Ml(t, yr, null) !== null;
};

const Fd = t => t;

const Ml = (t, n, e) => {
    if (kl(t) || Al(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Il = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const xl = (t, n, e, s, o = null) => {
    if (kl(n)) {
        Il(n, e, s);
        mn(t, Zo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Nl = t => {
    if (t.key) {
        return;
    }
    const n = au(t.node, ni);
    n && (t.key = n);
};

const Cl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (hi(c)) {
                bn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== ni && c) {
                if (c.startsWith(Nr)) {
                    const t = i.value;
                    t === "html" ? Il(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Il(e, "value", s.value);
                } else {
                    const t = i.value;
                    Il(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Ml(e, Hr, null) === null && Ml(e, Qr, null) === null || (n.flags |= 64);
    }
};

const Ol = t => {
    if (t.gt === "_run") {
        const n = t.getCaptured()?.[0];
        if (sr(n)) {
            return n;
        }
    }
    return t;
};

function bn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Ol(Fn(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function vn(t, n, e) {
    let s = ou(n);
    for (;s; ) {
        if (Tl(s)) {
            Ll(t, s);
            e(s, n);
        } else {
            kl(s) ? e(s, n) : vn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function _n(t) {
    let n = t;
    if (Tl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = ou(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const jl = (t, n, e) => {
    let s = t;
    for (;e && s && Al(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Al(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Al(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Tl(t) && e && kl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Pu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Ll = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Kl(n, !0);
        const o = e.node;
        const r = _u(s);
        let i = jl(n, !1, !0);
        const c = jl(n, !0, !0);
        const l = o || (c && kl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Tl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Go(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = jl(i, !1, !0);
        }
        i = n;
        for (;i && Tl(i); ) {
            const n = jl(i, !0, !0);
            const e = !n || !Tl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Yo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Go(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Fl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = _l(i);
            Nl(e);
            t.vNode = e;
            return e;
        }
    }
    if (Sl(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || _l(i);
            Nl(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = Wl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Vl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Xl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Xl = (t, n) => {
    let e = ou(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Dl = [];

const Wl = (t, n) => {
    let e = ou(t);
    for (;e && (!(e instanceof us) || e.node !== n); ) {
        if (Al(e)) {
            const t = e.nextSibling;
            const n = ou(e);
            if (n) {
                t && Dl.push(t);
                e = n;
            } else {
                e = t || (Dl.length ? Dl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Dl.pop();
        }
    }
    for (;Dl.length; ) {
        Dl.pop();
    }
    return e;
};

const Vl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Ul = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = vl(o, "errored-host");
    if (Rl(e)) {
        Zl(t, r, e, null);
    } else {
        const n = [];
        vn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Zl(t, r, n[e], null);
        }
    }
    return r;
};

const zl = en;

const Bl = (t, n, e, s) => {
    const o = kl(n);
    o && lu(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Yl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Kl(n, !1);
    l && !c && mn(t, Go(i, l, Ql(t, n, s)?.node ?? null));
    Jl(n, e, s);
    c && (e.flags |= 32);
};

const Hl = (t, n, e, r) => {
    const i = kl(n);
    i && lu(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Yl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[pr] : null;
    const f = u ? null : i ? n : tu(n, !1);
    const a = u || f?.node;
    const h = Ql(t, n, r);
    const d = h?.node ?? null;
    const p = ql(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = tu(n, !1);
        const c = Ql(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        vn(t, e, n => {
            if (Tl(n)) {
                mn(t, Go(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (kl(c)) {
                                e = c.node;
                                const t = ru(c);
                                const l = c.parent;
                                const h = u == null ? n : l && tu(l, !0);
                                if (h) {
                                    const t = o(h, ru(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = ou(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (cu(e)) {
                                    const t = Me(e);
                                    if (t) {
                                        const n = ou(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                mn(t, Go(n.node, a, c));
            }
        });
    } else {
        a && !l && vn(t, e, n => {
            mn(t, Go(n.node, a, d));
        });
    }
    Jl(n, e, r);
    l && (e.flags |= 32);
};

const Ql = (t, n, e) => {
    let s = null;
    e == null ? Al(n) && (s = jl(n, !0, !1)) : s = Al(e) ? jl(e, !0, !0) : e;
    s && Tl(s) && Ll(t, s);
    return s;
};

const Jl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Yl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && nu(t, n, s, !1);
};

const Gl = (t, n) => {
    let e = n;
    for (;e && Al(e); ) {
        e = e.lastChild;
    }
    e && Tl(e) && (e.flags & 8) === 0 && Ll(t, e);
};

const Zl = (t, n, e, s) => {
    Rl(e) ? Bl(t, n, e, s) : Hl(t, n, e, s);
};

const Kl = (t, n) => {
    for (;t && !kl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[pr];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const tu = (t, n) => {
    for (;t && !kl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const nu = (t, n, e, s) => {
    Tl(e) && Ll(t, e);
    if (s) {
        const s = Ml(n, ei, null) !== null;
        if (s) {
            return;
        }
        Rl(e) ? mn(t, Qo(e.node)) : vn(t, e, n => {
            mn(t, Qo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const eu = (t, n, e, s = !0) => {
    const o = Kl(n, !0);
    if (o && s) {
        if (Rl(n)) {
            mn(t, Jo(n.node));
        } else {
            const e = tu(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Jo(o)) : vn(t, n, n => {
                mn(t, Qo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const ru = t => {
    const n = Fd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = vu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = bu(t);
            switch (n) {
              case Fr:
                return 512;

              case Xr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const iu = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const su = (t, n, e) => {
    Ll(t, n);
    n.text = e;
    mn(t, Yo(n.node, e));
};

const ou = t => {
    if (Tl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && kl(t) && function e(t) {
        const n = t.getAttribute(xd);
        if (n === null) {
            return !1;
        }
        const e = mu(t);
        return Iu(e) && e.localName === "template" && e.getAttribute(vr) === n && $u(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = lu(t));
    return n;
};

const lu = n => {
    const e = Fd(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && cu(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = mu(e);
            const o = _u(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Nl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === fr && o.charCodeAt(1) === fr) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = gu(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = Iu(t);
                            return !n || n && kn(t);
                        };
                        let p = null;
                        Eu(e, ($, y, w, m, b, _) => {
                            if (Tu($())) {
                                for (;d(o); ) {
                                    o = $u(o);
                                    if (!o) {
                                        throw rr(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Tu($()); ) {
                                    t *= 10;
                                    t += w() - 48;
                                }
                                for (;t--; ) {
                                    const n = _l(o);
                                    Nl(n);
                                    u(n);
                                    o = $u(o);
                                    for (;Iu(o) && kn(o); ) {
                                        o = $u(o);
                                        if (!o && t > 0) {
                                            throw rr(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                Il(n, kr, y());
                            } else if ($() === 60) {
                                const e = y();
                                if (e.charCodeAt(0) === 95) {
                                    Il(n, dr, decodeURIComponent(t(e.slice(1))));
                                } else {
                                    (p ||= []).push(n);
                                    Il(n, hr, e);
                                }
                            } else if ($() === 61) {
                                h || (h = qe(s));
                                const t = y();
                                h.Yn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                Il(n, Ur, y());
                            } else if ($() === 64) {
                                n.key = _();
                            } else if ($() === 91) {
                                Il(n, zr, y());
                            } else if ($() === 94) {
                                Il(n, Br, y());
                            } else if ($() === 96) {
                                h || (h = qe(s));
                                En(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = qe(s));
                                n.slotParent = Fl(h.rootVNode, y());
                            } else if ($() === 93) {
                                Il(n, Rr, y());
                            } else if ($() === 123) {
                                w();
                                u(El());
                                qu.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === fr) {
                                const e = y();
                                const s = decodeURIComponent(t(e));
                                const o = b + e.length + 1;
                                const r = m(o + 1) === fr;
                                let i;
                                if (r) {
                                    w();
                                    i = decodeURI(t(y()));
                                    w();
                                } else {
                                    i = t(y());
                                }
                                Il(n, s, i);
                            } else if ($() === 125) {
                                w();
                                n.lastChild = c;
                                r = qu.pop();
                                l = qu.pop();
                                c = qu.pop();
                                i = qu.pop();
                                n = qu.pop();
                            } else if ($() === 126) {
                                Il(n, yr, _());
                            } else {
                                for (;Iu(o) && kn(o); ) {
                                    o = $u(o);
                                }
                                const t = o && hu(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Au($()); ) {
                                    n += w() - 97;
                                    n *= 26;
                                }
                                n += w() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new cs(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = qe(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return gu(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let uu = null;

const cu = t => {
    uu || (uu = t.hasAttribute);
    return uu.call(t, Nr);
};

let fu = null;

const au = (t, n) => {
    fu || (fu = t.getAttribute);
    return fu.call(t, n);
};

const hu = bl("nodeType");

const du = t => {
    const n = hu(t);
    return n === 3 || n === 1;
};

let pu = null;

const $u = t => {
    pu || (pu = ml(t, "nextSibling"));
    wu || (wu = ml(t, "firstChild"));
    for (;t; ) {
        t = pu.call(t);
        if (t !== null) {
            const n = hu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Ir)) {
                    return gn(t, qr, pu, wu);
                }
                if (t.nodeValue?.startsWith(Mr)) {
                    return gn(t, [ qr, xr ], pu, wu);
                }
                if (n?.startsWith(Nr)) {
                    for (;t && (t = pu.call(t)) && (hu(t) !== 8 || !t.nodeValue?.startsWith(Cr)); ) {}
                }
            }
        }
    }
    return t;
};

function gn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = yu(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const yu = bl("parentNode");

let wu = null;

const mu = t => {
    wu || (wu = ml(t, "firstChild"));
    t = t && wu.call(t);
    if (t && hu(t) === 8) {
        pu || (pu = ml(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Ir)) {
            return gn(t, qr, pu, wu);
        }
    }
    for (;t && !du(t); ) {
        t = $u(t);
    }
    return t;
};

const bu = bl("namespaceURI");

const vu = bl("nodeName");

const _u = bl("ownerDocument");

const gu = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;Iu(i) && kn(i); ) {
            i = $u(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = hu(i);
        let e = null;
        if (n === 3) {
            e = gl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = _l(i);
            Nl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = $u(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Eu(e, (e, s) => {
            if (e() === 61) {
                n || (n = qe(t.node));
                const e = s();
                n.Yn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = qe(t.node));
                En(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function En(t, n, e) {
    if (t[ts]) {
        const s = t[ts];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, ts, {
            get() {
                const s = e.k(n);
                t[ts] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, ts, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Eu = (n, e) => {
    let s = 0;
    let o = 0;
    let r = 0;
    const i = t => t < n.length ? n.charCodeAt(t) : 0;
    const c = () => r !== 0 ? r : r = i(s);
    const l = () => {
        o = c();
        r = 0;
        s++;
        return o;
    };
    const u = () => {
        l();
        const t = s;
        for (;c() <= 58 && r !== 0 || r === 92 || r === 95 || r >= 65 && r <= 90 || r >= 97 && r <= 122; ) {
            l();
        }
        return n.substring(t, s);
    };
    const f = () => {
        if (i(s + 1) !== fr) {
            return u();
        }
        l();
        const n = decodeURIComponent(t(u()));
        l();
        return n;
    };
    for (;c() !== 0; ) {
        e(c, u, l, i, s, f);
    }
};

const Su = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Cl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(ni) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const ku = (t, n) => {
    let e = Ru(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Ru(e);
    }
    return !1;
};

const Ru = t => t.parent || t.slotParent;

const Pu = t => {
    if (t === null || Al(t)) {
        return null;
    }
    return t.node;
};

function Sn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (kl(e)) {
                        const t = Ie(e.node);
                        if (!t) {
                            return null;
                        }
                        return Me(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Tl(i)) {
            c.push(In(iu(i)));
        } else if (Al(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Su(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== or && e !== "__scopedStyleIdPrefix__") {
                        const t = Ml(i, e, null);
                        s.push(" " + e + "=" + In(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (lr[Ml(i, or, null) || "V"] || lr.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = ou(i);
            u && c.push("  " + Sn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (kl(i)) {
            const s = ru(i);
            const l = [];
            pn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Su(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Ml(i, n, null);
                l.push(" " + n + "=" + In(e));
            }
            const f = Pu(i);
            if (f) {
                const t = _u(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + In(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + In(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Pl(i) || e) {
                const e = ou(i);
                e && c.push("  " + Sn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Tu = t => 48 <= t && t <= 57;

const Au = t => 97 <= t && t <= 122;

function kn(t) {
    return !t.hasAttribute(ni) || t.nodeName === "STYLE" && (t.hasAttribute(kr) || t.hasAttribute(gr));
}

const qu = [];

const Mu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw rr(26, [ n ]);
};

const Iu = t => t && typeof t == "object" && hu(t) === 1;

const xu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Al(t) || Ml(t, hr, null) === null); ) {
            const e = t.slotParent;
            const s = Al(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Rn(t, n) {
    Sl(n) && kl(n) && lu(n);
    const e = n[ts];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Pn(t, n);
    }
    e.clear();
}

function Pn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Xs) {
            Tn(t, s, n);
            s instanceof Ws && An(s, n);
        } else if (xs(s)) {
            const t = s[_s];
            qn(t, n);
        } else if (t.yt.has(s)) {
            const e = t.yt.get(s);
            const o = Yu(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Tn(t, n, e) {
    const s = n.ht;
    s && s.has(e) && s.delete(e);
    if (n instanceof so && !s?.size) {
        n._ = void 0;
        Rn(t, n);
    }
}

function An(t, n) {
    const e = t.wt;
    e && e.has(n) && e.delete(n);
    const s = t.bt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function qn(t, n) {
    const e = t?.ht;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Nu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Ko();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Ou(6 | i, r, o._, t, null);
    s(c);
    const l = o.$;
    const {dn: u} = o;
    const f = li(u, () => Cu(c, l, o._));
    si(f) && (o.dn = f);
};

const Cu = (t, n, e) => {
    const s = t.Gn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => {
        zf(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = li(((t, n) => {
        const e = t.Zn;
        if (e) {
            return e;
        }
        const s = t.$n;
        if (!s) {
            return;
        }
        t.$n = null;
        try {
            const e = s();
            if (si(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Zn === s && (t.Zn = void 0);
                });
                t.Zn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = Fe(n.fn, e, "qTask");
        s.$ = n;
        const i = t._t.getFn(s, () => Rn(n, t));
        const c = Fs(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.$n = () => {
                            t.$n = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    si(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return oi(() => i(u), l, s => {
            if (si(s)) {
                return s.then(() => {
                    t.Gn === r && (t.Gn = null);
                    return Cu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (si(i)) {
        r = i.finally(() => {
            t.Gn === r && (t.Gn = null);
        });
        t.Gn = r;
        return r;
    }
    return i;
};

class Ou extends ns {
    h;
    Xt;
    dt;
    _t;
    $n;
    Zn;
    Gn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Xt = n;
        this.dt = e;
        this._t = s;
        this.$n = o;
    }
}

const ju = t => t instanceof Ou;

function Mn(t, n) {
    const e = qe(n);
    return na(e, () => {
        typeof this === "string" && Ta(Aa(e, this));
        const t = Pa[0];
        if (!t.dt) {
            return;
        }
        t.h |= 4;
        wn(e, t.dt, 1);
    });
}

const Lu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Fu = t => t instanceof Xs;

const Xu = (t, n) => {
    t.add(n);
};

const Du = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Wu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        ju(e) ? o = e._t : e instanceof Ws ? o = e.Wt : s === ":" && (o = n.getHostProp(e, hr));
        o && n.serializationCtx.Ft.add(o);
    }
};

const Vu = (t, n) => {
    if (t && (!n || t === n || jd(t))) {
        return t;
    }
    return n;
};

const Uu = (t, n, e) => {
    const s = Ve;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (ju(o)) {
                o.h |= 4;
                wn(t, o.dt, 1);
            } else if (o instanceof Xs) {
                o.invalidate();
            } else if (r === ":") {
                wn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    zt(o, n);
                    wn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof oo) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[ds];
                            if (!o) {
                                o = new Map;
                                s[ds] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(ds);
                        if (!n) {
                            n = new Map;
                            t.setProp(ds, n);
                        }
                        n.set(r, c);
                    }
                    wn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const zu = t => Ke(t) && typeof t[Tf] === "function";

const Bu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Hu = t => {
    t.h |= 4;
};

const Qu = [];

function In(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (ju(t)) {
            return `Task(${In(t._t)})`;
        }
        if (sr(t)) {
            return `Qrl(${t.gt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Qu.includes(t)) {
                return "*";
            }
            Qu.length;
            try {
                Qu.push(t);
                if (Array.isArray(t)) {
                    return Sl(t) ? "(" + (Ml(t, or, null) || "vnode") + ")" : t.map(In);
                }
                if (Fu(t)) {
                    return t instanceof so ? "WrappedSignal" : t instanceof Ws ? "ComputedSignal" : "Signal";
                }
                if (nc(t)) {
                    return "Store";
                }
                if (co(t)) {
                    return Ju(t);
                }
                if (Sl(t)) {
                    return "(" + (Ml(t, or, null) || "vnode") + ")";
                }
            } finally {
                Qu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Ju = t => {
    if (co(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Ba];
            if (n) {
                const [t] = n;
                return "Component(" + t.gt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + In(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Ju(e);
                    }
                } else {
                    n += Ju(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Yu = t => t[js];

const Gu = t => {
    try {
        return t?.[Os] || null;
    } catch {
        return null;
    }
};

const Zu = (t, n) => {
    const e = Yu(t);
    e && e.force(n);
};

const Ku = (t, n) => {
    const e = Yu(t);
    if (e) {
        return (e.ht?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const tc = t => Gu(t) || t;

const nc = t => Os in t;

function xn(t, n, e) {
    return new Proxy(n, new rc(e, t || null));
}

const ec = (t, n, e) => {
    if (Ze(t) && e) {
        let s = e.yt.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.yt.set(t, s);
        }
        return s;
    }
    return t;
};

class rc {
    h;
    $;
    ht=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Gu(this);
        Uu(this.$, this, On(n, t, this.ht));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Os) {
                return t;
            }
            if (n === js) {
                return this;
            }
            return t[n];
        }
        const e = sa();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.hn;
            o && Nn(t, Array.isArray(t) ? Ls : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ke(s)) {
            try {
                r = !Object.isFrozen(s) && !nc(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return ec(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? tc(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Cn(n, s, t, this);
        } else {
            Cn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Uu(this.$, this, On(t, n, this.ht));
        return !0;
    }
    has(t, n) {
        if (n === Os) {
            return !0;
        }
        if (typeof n === "string") {
            const e = sa();
            if (e) {
                const s = e.hn;
                s && Nn(t, Array.isArray(t) ? Ls : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = sa();
        const e = n?.hn;
        e && Nn(t, Ls, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Nn(t, n, e, s, o) {
    const r = e.ht ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = We;
    const l = __EXPERIMENTAL__.suspense && e instanceof rc && c;
    Xu(i, s);
    Du(s, t);
    if (c) {
        const i = Vu(o, e.$);
        l && i?.Tn?.(t, s, n, r);
        Wu(s, i);
    }
}

function Cn(t, n, e, s) {
    e[t] = n;
    const o = On(e, t, s.ht);
    o && Uu(s.$, s, o);
}

function On(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Ls);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const ic = Symbol();

const sc = [ void 0, null, !0, !1, "", Ss, ks, Ns, Ls, Es, Mo, Ao, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const oc = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const lc = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function jn(t, n, e) {
    let s = n.gt;
    let o = n.Et;
    const r = Pi();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => sr(t) && t.gt == ir)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.St(null, 0, e) + "";
    } else {
        o || (o = t.kt(n.ot));
        if (!o) {
            throw rr(14, [ n.gt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.Rt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Ln(t, n, e, s) {
    return xa(t, n, null, null, e, s);
}

function Fn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Ln(o, r, i, n);
}

class uc {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class cc {
    Kn;
    te=0;
    Tt=[];
    ne=0;
    ee=new Set;
    re=new Map;
    ie;
    se=new Map;
    oe=0;
    Yt;
    le=typeof Temporal !== "undefined";
    constructor(t) {
        this.Kn = t;
        this.Yt = t.Yt;
    }
    async serialize() {
        const t = this.oe;
        this.oe = 0;
        try {
            await this.outputRoots();
        } finally {
            this.oe = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.oe;
        this.oe = s;
        this.Yt.write(Qi);
        this.Kn.ue = 0;
        try {
            this.Yt.write(t + "");
            this.Yt.write(Yi);
            this.Yt.write(Qi);
            await this.outputSelectedRoots(n);
            this.Yt.write(Ji);
            const s = this.getForwardRefsPayload();
            this.Kn.ue = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Yt.write(Yi);
                s ? this.outputForwardRefsArray(s) : this.Yt.write("0");
            }
            if (e !== void 0) {
                this.Yt.write(Yi);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Yt.write(Hi);
                    this.writeRootRefPath(e);
                    this.Yt.write(Hi);
                }
            }
        } finally {
            this.oe = o;
        }
        this.Yt.write(Ji);
    }
    ce(t) {
        this.Yt = t;
    }
    outputArray(t, n, e) {
        this.Yt.write(Qi);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Yt.write(Yi) : s = !0;
            e(t[n], n);
        }
        this.Yt.write(Ji);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Hi + t + Hi;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Yt.write(n.slice(s, e));
            this.Yt.write("<\\/");
            s = e + 2;
        }
        this.Yt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Yt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Yt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Yt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Yt.write(Hi);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Yt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Yt.write(Hi);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Yt.write(t + Yi);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Yt.write(Hi);
                this.writeRootRefPath(n);
                this.Yt.write(Hi);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Yt.write(t + Yi);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Yt.write(t + Yi + n);
        } else if (typeof n === "string") {
            this.Yt.write(t + Yi);
            this.outputString(n);
        } else {
            this.Yt.write(t + Yi);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Kn.getSeenRef(t);
        const o = !e && this.re.get(t);
        if (s) {
            s.ie && this.isSeenInStreamedRoot(s) && (s = this.Kn.fe(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Kn.ae(t, this.ie, n);
            }
            s = this.Kn.Rt(t, !0);
        }
        if (s.ie) {
            if (this.ie) {
                this.Kn.he(s, t);
            } else {
                this.Kn.he(s, t, n);
                t = this.Kn.de[n];
            }
        }
        if (typeof o === "number") {
            this.Tt[o] = s.Xt;
            this.re.delete(t);
        }
        const r = t instanceof bc ? t.pe : s.Xt;
        if (!this.ie && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.ie; ) {
            t = t.ie;
        }
        return t.Xt < this.oe;
    }
    writeValue(t, n) {
        if (kf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Ns) {
                    this.output(3, 7);
                } else if (t === Ls) {
                    this.output(3, 8);
                } else if (t === Es) {
                    this.output(3, 9);
                } else {
                    if (t !== ic) {
                        throw rr(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === Mo) {
                    this.output(3, 10);
                } else if (t === Ao) {
                    this.output(3, 11);
                } else if (sr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = jn(this.Kn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Kn.Rt(n);
                            const i = this.Kn.Rt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.se.get(l);
                            if (u) {
                                const t = this.Kn.Rt(u);
                                this.output(1, t);
                                return;
                            }
                            this.se.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Ha(t)) {
                        throw rr(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Ba];
                        this.Kn.$e.add(n.gt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Ss) {
                    this.output(3, 5);
                } else if (t === ks) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof bc) {
                    this.output(1, t.pe);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.ie;
                        this.ie = e;
                        this.writeObjectValue(t);
                        this.ie = n;
                    }
                }
                break;

              default:
                throw rr(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (xs(t)) {
            const n = t[vs];
            this.output(38, [ wc(n), n.varProps, n.constProps, t[_s].ht ]);
        } else if (t instanceof oo) {
            const {j: n, rt: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Cs) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof uc) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (nc(t)) {
            const n = Yu(t);
            const e = Gu(t);
            const s = n.h;
            const o = n.ht;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Kn.yt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (zu(t)) {
            const n = t[Tf](t);
            if (si(n)) {
                const t = this.resolvePromise(n, (t, n) => new fc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.ie.Xt;
                this.ie = this.ie.ie;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        kf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Kn.ye(t)) {
            this.Kn.we(t.me, 16);
            this.output(11, t.me.id);
        } else if (t instanceof Xs) {
            if (t instanceof Us) {
                const n = function e(t, n) {
                    if (n === Ns) {
                        return n;
                    }
                    return li(t.Wt.resolved || t.Wt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Tf in n && (e = n[Tf](n));
                        e === void 0 && (e = Ns);
                        return e;
                    });
                }(t, t.Dt);
                if (si(n)) {
                    const e = this.resolvePromise(n, (n, e) => new fc(34, n, e, t.ht, t.Wt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Wt, t.ht, n ]);
                }
                return;
            }
            if (t instanceof so) {
                this.output(31, [ ...Xn(this.Kn, t), t.h, t._, ...t.ht || [] ]);
            } else if (t instanceof Ws) {
                let n = t.Dt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = kf(t.Dt);
                const i = !!(t.h & 512);
                const c = i && !!t.Vt;
                const l = i && t.zt !== 1 ? t.zt : void 0;
                const u = i && t.Ht !== 0 ? t.Ht : void 0;
                const f = i && t.h & -25 || void 0;
                o || r || c ? n = Ns : e ? n = t.Dt : s && (n = Ns);
                const a = [ t.Wt, t.ht ];
                if (i) {
                    const n = t.Vt;
                    a.push(t.wt, t.bt, n === void 0 ? n : Lf(n));
                    a.push(f || void 0);
                }
                n === Ns && l === void 0 && u === void 0 || a.push(n === void 0 ? ic : n);
                if (i) {
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Dt;
                const e = [ n === void 0 ? ic : n ];
                t.ht && e.push(...t.ht);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.Kn.be(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Kn.Rt(t);
            this.Kn.ve(t, Wr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                ac(e, this.Kn);
                this.Kn.we(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Kn.we(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (co(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Ou) {
            const n = [ t._t, t.h, t.Xt, t.dt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (si(t)) {
            const n = this.resolvePromise(t, (t, n) => new fc(24, t, n));
            this.output(2, n);
        } else if (t instanceof fc) {
            if (t._e === 34) {
                if (t._t) {
                    this.output(34, [ t._t, t.ht, t.ge ]);
                } else {
                    if (!t.Ee) {
                        console.error(t.ge);
                        throw rr(33);
                    }
                    {
                        const n = this.ie.Xt;
                        this.ie = this.ie.ie;
                        this.writeValue(t.ge, n);
                    }
                }
            } else {
                this.output(24, [ t.Ee, t.ge ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof yc) {
            const n = t.Se;
            if (this.getSeenRefOrOutput(n, this.ie.Xt, !0)) {
                let t = this.re.get(n);
                if (t === void 0) {
                    t = this.ne++;
                    this.re.set(n, t);
                    this.Tt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.le && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.le && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.le && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.le && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.le && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.le && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.le && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.le && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!Sl(t)) {
                throw rr(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.ne++;
        t.then(s => {
            this.ee.delete(t);
            this.Tt[e] = this.Kn.Rt(n(!0, s));
        }).catch(s => {
            this.ee.delete(t);
            this.Tt[e] = this.Kn.Rt(n(!1, s));
        });
        this.ee.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Kn.ke + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {de: n} = this.Kn;
        for (;this.te < n.length || this.ee.size; ) {
            let e = t > 0;
            for (;this.te < n.length; this.te++) {
                e ? this.Yt.write(Yi) : e = !0;
                this.writeValue(n[this.te], this.te);
                t++;
            }
            if (this.ee.size) {
                try {
                    await Promise.race(this.ee);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.ee.size; ) {
            if (e < t.length) {
                n ? this.Yt.write(Yi) : n = !0;
                const s = t[e++];
                this.writeValue(this.Kn.de[s], s);
                continue;
            }
            try {
                await Promise.race(this.ee);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Tt.length - 1;
        for (;t >= 0 && this.Tt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Tt.length - 1 ? this.Tt : this.Tt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Yt.write(Hi);
                this.writeRootRefPath(t);
                this.Yt.write(Hi);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Yt.write(Qi);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Kn.Re = this.Kn.de.length;
        this.Kn.Pe = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Yt.write(Yi);
            this.Yt.write(14 + Yi);
            this.outputForwardRefsArray(n);
        }
        this.Yt.write(Ji);
        this.Kn.Te = this.Kn.de.length + (this.Kn.Pe ? 1 : 0);
        this.Kn.ue = e;
    }
}

class fc {
    _e;
    Ee;
    ge;
    ht;
    _t;
    constructor(t, n, e, s, o) {
        this._e = t;
        this.Ee = n;
        this.ge = e;
        this.ht = s;
        this._t = o;
    }
}

const ac = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (hc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Wr || t === Ur && (zi(s) || dc(e, s))) {
                    continue;
                }
                n.Rt(s);
            }
        }
    }
};

const hc = t => typeof t === "object" && t !== null && !zi(t);

const dc = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, hr)) {
        return !1;
    }
    const s = n[vs];
    return zi(s.varProps) && !pc(n) && !$c(t[Pr]);
};

const pc = t => !!t[_s].ht?.size;

const $c = t => t instanceof Map && t.has(":");

function Xn(t, n) {
    n.Pt && n.Pt[0] === "{" && (n.Pt = `(${n.Pt})`);
    const e = t.St(n.Pt, n.ct.length, n.ut);
    return [ e, n.ct ];
}

class yc {
    Se;
    constructor(t) {
        this.Se = t;
    }
}

const wc = t => new yc(t);

let mc = () => !1;

class bc {
    pe;
    constructor(t) {
        this.pe = t;
    }
}

class vc {
    NodeConstructor;
    DomRefConstructor;
    kt;
    ve;
    yt;
    Yt;
    Ae=new Map;
    qe=new Map;
    Me=0;
    Ie=[];
    de=[];
    xe=[];
    Ne;
    ke=0;
    Te=0;
    ue=0;
    Re=0;
    Pe=!1;
    Ce=new Set;
    Ft=new Set;
    Lt=new Set;
    $e=new Set;
    Oe;
    we=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.kt = e;
        this.ve = s;
        this.yt = o;
        this.Yt = r;
        this.Oe = new cc(this);
    }
    async Jt() {
        await this.Oe.serialize();
    }
    async je(t, n, e, s) {
        await this.Oe.serializePatch(t, n, e, s);
    }
    ce(t) {
        this.Yt = t;
        this.Oe.ce(t);
    }
    getSeenRef(t) {
        return this.Ae.get(t);
    }
    ae(t, n, e) {
        const s = {
            Xt: e,
            ie: n
        };
        this.Ae.set(t, s);
        return s;
    }
    Le(t) {
        const n = [];
        for (;t.ie; ) {
            n.unshift(t.Xt);
            t = t.ie;
        }
        n.unshift(t.Xt);
        return n;
    }
    he(t, n, e) {
        const s = this.Le(t);
        const o = e === void 0;
        e === void 0 && (e = this.de.length);
        this.de[e] = new bc(s);
        o && (this.xe[e] = n);
        t.ie = null;
        t.Xt = e;
        o && this.Ne?.(e, this.de[e], n);
    }
    Rt(t, n = !1) {
        let e = this.Ae.get(t);
        let s;
        if (e) {
            e.ie && this.he(e, t);
            s = e.Xt;
        } else {
            s = this.de.length;
            e = {
                Xt: s
            };
            this.Ae.set(t, e);
            this.de.push(t);
            this.xe.push(t);
            this.Ne?.(s, t, t);
        }
        return n ? e : s;
    }
    fe(t) {
        const n = this.de.length;
        const e = {
            Xt: n
        };
        this.Ae.set(t, e);
        this.de.push(t);
        this.xe.push(t);
        this.Ne?.(n, t, t);
        return e;
    }
    Fe(t, n) {
        const e = this.de.length;
        const s = {
            Xt: e
        };
        this.Ae.set(n, s);
        this.de.push(t);
        this.xe.push(n);
        return e;
    }
    be(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    ye(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Xe(t) {
        const n = this.Ae.get(t);
        return n && (n.ie ? void 0 : n.Xt);
    }
    St(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.qe.get(t);
        if (o === void 0) {
            o = this.Me + this.Ie.length;
            this.qe.set(t, o);
            if (s) {
                this.Ie.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Ie.push(e += ")=>" + t);
            }
        }
        return o;
    }
    De(t, n) {
        this.Me = t;
        if (n) {
            this.qe.clear();
            for (let t = 0; t < n.length; t++) {
                this.qe.set(n[t], t);
            }
        }
    }
}

const _c = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Bi(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    mc = n ? t => t instanceof n : () => !1;
    return new vc(t, n, e, s, o, r);
};

const gc = (t, n) => t[n];

const Ec = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        nc(t) && (t = Gu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Ec(ca(gc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Ec(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (ju(t)) {
            return !0;
        }
        if (xs(t)) {
            return !0;
        }
        if (si(t)) {
            return !0;
        }
        if (co(t)) {
            return !0;
        }
        if (zu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof oo) {
            return !0;
        }
        if (mc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (sr(t) || Ha(t) || t === Mo || t === Ao) {
            return !0;
        }
    } else if (t === Es || t === Ns || t === Ls) {
        return !0;
    }
    return !1;
};

const Sc = (t, n) => {
    let e = Sl(t) ? Sn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ke(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let kc = !1;

const Rc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (kc = !0);
            const n = `{${Ke(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Sc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Tc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Rc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Pc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = kc ? "" : `(${JSON.stringify(t).length} chars)`;
        kc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Pc = t => lc[t] || `Unknown(${t})`;

const Tc = t => oc[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Wn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Wn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Tt = t[i + 1]);
        yield;
    }
}

const Ac = new WeakMap;

const qc = /^[A-Za-z0-9+/]*$/;

const Mc = t => {
    const n = t.Qt === void 0;
    t.Qt ??= new Map;
    return n;
};

const Ic = (t, n) => {
    if (n) {
        t.Qt.clear();
        t.Qt = void 0;
    }
};

const xc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Zt(e);
        return s === -1 || s === void 0 ? Es : t.k(s);

      case 14:
        return e;

      case 3:
        return sc[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.k(i);
                const f = t.k(l);
                n = Ln(u, f, r !== -1 ? s : null, t);
            } else {
                n = Ln("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Ou(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return za(null);

      case 30:
        return new Xs(t, 0);

      case 31:
        return new so(t, null, null, null);

      case 32:
        return new Ws(t, null);

      case 33:
        return new zs(t, null, void 0, {});

      case 34:
        return new Us(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = xc(t, s, o);
            const i = ec(r, 0, t);
            df(s) && t.Qt.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new lo(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Ac.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !qc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw rr(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return w(null);

      case 10:
        return Vn(t, e);

      case 11:
        const l = Vn(t, e);
        if (Sl(l)) {
            lu(l);
            return Pu(l);
        }
        throw rr(17, [ typeof l ]);

      case 39:
        return new oo({});

      case 42:
        return new oo({
            j: null,
            rt: !0
        });

      case 43:
        return new oo({
            j: null,
            rt: !1
        });

      case 40:
      case 44:
        return new Cs(null, null, null, null);

      case 41:
        return new uc;

      default:
        throw rr(18, [ n ]);
    }
};

function Vn(t, n) {
    return n ? t.rootVNode ? Fl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Nc = (t, n, e) => {
    let s = null;
    let o = null;
    if (er(t)) {
        o = t;
    } else {
        if (!nr(t)) {
            throw rr(7, [ t ]);
        }
        s = t;
    }
    return xa(s, n, null, o, e);
};

const Cc = (t, n, e) => xa(null, n, t, null, e);

const Oc = (t, n) => xa(null, t, null, null, n);

const jc = (t, n, e) => {
    const s = Oc(t, e);
    return s;
};

const Lc = (t, n, e, s) => xa(t, e, null, n, s);

const Fc = (t, n, e, s, o) => {
    const r = Lc(t, n, e, o);
    r.We(s);
    return r;
};

const Xc = (t, n, e, s) => {
    const o = Nc(t, n, s);
    return o;
};

const Dc = (t, n, e, s) => {
    const o = Cc(t, n, s);
    return o;
};

const Wc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Vc = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Uc = (t, n, e) => new so(null, t, n, e || null);

class zc {
    Ve;
    yt;
    Rn=null;
    It=!1;
    fn;
    k;
    pn;
    Ue=0;
    Kt=null;
    ze=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.pn = t;
        this.fn = n;
        this.Ve = Gi;
        this.yt = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ha(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return _c(t, n, e, this.setHostProp.bind(this), this.yt, s);
    }
    $t() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Bc = Symbol();

const Xd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Bc] = t;
    return n;
};

class Hc {}

class Qc {}

const Jc = t => {
    const n = t.At;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Yc = t => {
    t.catch(() => {});
};

function zn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Bn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Yc(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Hc) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                        continue;
                    }
                    e = "hook";
                    await n(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && c === Qc) {
                    const n = o.pop();
                    if (Jc(t)) {
                        continue;
                    }
                    const e = n.apply(t);
                    si(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const n = o.pop();
                        if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                            continue;
                        }
                        o.push(await n);
                    } else {
                        const n = c.apply(t);
                        si(n) && await n;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                    si(c) && c.catch(() => {});
                    continue;
                }
                Qn(t, r, i, c, s);
            } catch (n) {
                t.handleError(n, t.getOrCreateLastNode(), e);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                si(n) && await n;
            }
        }
    })();
}

function Hn(t, n) {
    t(n);
    __EXPERIMENTAL__.errorBoundary && typeof n === "function" && t(Qc);
}

function Qn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Hn(n, s[t]);
            }
        } else if (Fu(s)) {
            t.openFragment(ks);
            const e = t.getOrCreateLastNode();
            const o = s instanceof so ? s.st() : s;
            n(t.closeFragment);
            n(() => ha(o, e, ".", t));
            n(Hc);
        } else if (si(s)) {
            t.openFragment(ks);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Bn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Bn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = As(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.errorBoundary && As(r, _r) && n(((t, n) => {
                    const e = t.At;
                    t.At = n;
                    return () => {
                        t.At = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Hn(n, l);
            } else if (er(i)) {
                if ((__EXPERIMENTAL__.suspense || __EXPERIMENTAL__.errorBoundary) && (t => typeof t === "function" && Bc in t)(i)) {
                    n(() => (t => t[Bc])(i)(t, r, o, n));
                    return;
                }
                if (i === Ao) {
                    const e = r.key != null ? {
                        [Vr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Hn(n, s);
                } else if (i === Mo) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[wr] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[yr] = u;
                        n(zn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Hn(n, a);
                        n(zn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ks;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === No) {
                    t.commentNode(As(r, "data") || "");
                } else if (i === Oo) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = er(s) ? s({
                        async write(n) {
                            await Bn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    si(i) ? e(i) : n(i);
                } else if (i === xo) {
                    t.htmlNode(As(r, "data"));
                } else if (i === Co) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Hn(n, r.children);
                } else if (Ha(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(zn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Ba];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(hr, o);
                        s.setProp(Ur, r);
                        n.key !== null && s.setProp(Vr, n.key);
                        return ul(t, s, s, o, r);
                    })(t, r, i);
                    if (si(l)) {
                        Yc(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = ai(s.getProp(kr));
                            n(e);
                            n(zn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = ai(s.getProp(kr));
                        n(zn(o, t, c));
                    }
                } else {
                    const s = {
                        [Vr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return ul(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    si(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Jn(t, n, e, s) {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = Gn(o);
        if (!e || !e.Mt) {
            continue;
        }
        if (t.It && e.xt) {
            throw n;
        }
        Bf(e, n, s);
        Ki(t).Nt = !0;
        t.It && Vf(e);
        Yn(t, o, e);
        return;
    }
    throw n;
}

function Yn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = Gn(t);
            n?.error === void 0 && k(t.getProp(Ur)) || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            Zn(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.Ct(o);
        } else if (s?.id) {
            t.Ct(s);
            e.projectedContentOwner = s;
        }
    }
}

function Gn(t) {
    const n = t.getProp(Rr);
    return n ? Ye(n, xf.id, 0) : null;
}

function Zn(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(wr);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp(yr) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Rn(t, n);
    const r = n.getProp(zr);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            ju(e) && Rn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            Zn(t, i[n], e, s);
        }
    }
}

const Gc = () => Pa;

const Zc = async t => {
    const [n, e] = Pa;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Kc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e) {
        return e;
    }
    const r = xa(null, "_rsc", Zc, null, [ t, {} ], o.$);
    const i = Qs(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const tf = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (si(t)) {
        return t.then(n, s);
    }
    const o = nf(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return si(i) ? i.then(n, s) : n(i);
};

const nf = t => t && t.__brand === "resource";

function Kn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n.gt.startsWith("_") && (Array.isArray(n.Ot) || s && n.jt) && (n = xa(null, "_run", N, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = jn(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (sr(o)) {
                i(c(o));
                te(t, n, o);
            } else if (o != null) {
                const e = Kn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (sr(r)) {
        o = c(r);
        te(t, n, r);
    }
    return o;
}

function te(t, n, e) {
    const s = $i(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Lt.add(r);
        t.Ft.add(e);
    }
}

const ef = (t, n, e) => {
    of(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const rf = (t, n, e) => {
    of(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const sf = (t, n, e) => {
    of(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const of = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = lf();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + pi(i), e, s);
            }
        } else {
            r(t + pi(n), e, s);
        }
    }
};

const lf = () => {
    const t = la();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Yr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Yr, s);
    }
    let o = t.$.getHostProp(e, Gr);
    o === null && (o = 0);
    t.$.setHostProp(e, Gr, o + 1);
    let r = t.$.getHostProp(e, Zr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Zr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const uf = function(t, n) {
    const e = qe(n);
    return na(e, () => {
        typeof this === "string" && Ta(Aa(e, this));
        const s = Pa?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = Pa?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        wn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let cf;

function ne(t) {
    const n = sa();
    if (!n) {
        return;
    }
    cf ||= Cc(uf, "_hmr");
    const e = n._;
    const s = cf.w([ e, t ]);
    rf("qHmr", s);
}

function ee(t, n, e, s, o) {
    const r = El();
    Il(r, yr, o);
    r.parent = n;
    Il(n, o, r);
    Il(r, hr, e);
    Il(r, Ur, s);
    r.dirty = 4;
    dn(t, r, 1);
    return r;
}

function re(t, n) {
    Il(t, pr, n);
    t.flags |= 2048;
}

function ie(t, n, e) {
    Il(n, Ur, e);
    wn(t, n, 4);
}

function se(t, n, e, s) {
    Il(n, s, null);
    const o = [];
    St(t, o, e);
    zl(o);
    if (e.flags & 2048) {
        const t = Ml(e, pr, null);
        t && t.replaceChildren();
        Il(e, pr, null);
        e.flags &= -2049;
    }
}

let ff = Promise.resolve();

const af = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const hf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !af.has(t));
};

function* oe(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ue(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* le(t, n, e = Array(n.length / 2)) {
    const s = Mc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.k;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : xc(t, i, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            df(r) && (yield* ce(t, c, r, i));
            yield;
        }
    } finally {
        t.k = i;
        Ic(t, s);
    }
    return e;
}

function* ue(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = xc(t, n, e);
    df(n) && (yield* ce(t, s, n, e));
    return s;
}

function* ce(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* oe(t, s));
    switch (e) {
      case 4:
        yield* oe(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!hf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Ac.get(t);
            if (e) {
                if (Ac.has(o)) {
                    throw rr(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                hf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t._t = e[0];
            t.h = e[1];
            t.Xt = e[2];
            t.dt = e[3];
            break;
        }

      case 29:
        n[Ba][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Dt = e[0];
            t.ht = new Set(e.slice(1));
            ae(t.ht, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ut = t.getSyncFn(o[0]);
            e.ct = o[1];
            e.Dt = Ns;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ht = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && Sl(t._)) {
                    const n = t._;
                    const e = t.ht;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (nr(e)) {
                                const o = Ml(n, e, null);
                                if (o !== null) {
                                    t.Dt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = ou(n);
                        e && n.firstChild === n.lastChild && Tl(e) && (t.Dt = iu(e));
                    }
                }
            })(e);
            ae(e.ht, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Wt = e[0];
            e[1] && (t.ht = new Set(e[1]));
            e[2] && (t.wt = new Set(e[2]));
            e[3] && (t.bt = new Set(e[3]));
            e[4] && (t.Vt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Ut = !0);
            const o = e.length > 6;
            o && (t.Dt = e[6]);
            t.Dt === Ns && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.zt = e[7] ?? 1;
                t.Bt = [];
            }
            t.Ht = e[8] ?? 0;
            ae(t.ht, t);
            ae(t.wt, t);
            ae(t.bt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Wt = r[0];
            const i = o.Wt.resolve(t).catch(() => {});
            ff = ff.finally(() => i);
            r[1] && (o.ht = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Dt = r[2]);
            e !== 34 && o.Dt !== Ns && (o.h &= -2);
            ae(o.ht, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === Es) {
                o = new lo(Ao, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[vs] = o;
            const r = t[_s];
            r.ht = e[3];
            he(r.ht, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.rt = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            fe(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            fe(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = tc(n);
            const o = t.Qt.get(e);
            if (o) {
                t.Qt.delete(e);
                yield* ce(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Yu(n);
            c.h = r;
            c.ht = i;
            he(c.ht, e);
            break;
        }

      default:
        throw rr(16, [ e ]);
    }
}

function fe(t) {
    const n = We;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[ts] ||= new Map;
    e[ts].set(t.property, t);
}

function ae(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function he(t, n) {
    if (t) {
        for (const [, e] of t) {
            ae(e, n);
        }
    }
}

const df = t => t >= 23 || t === 4 || t === 5;

const pf = new WeakMap;

const $f = Symbol();

const yf = (t, n) => {
    if (!Array.isArray(n) || Sl(n) || (t => Ke(t) && $f in t)(n)) {
        return n;
    }
    let e = pf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new wf(t, n));
        pf.set(n, e);
    }
    return e;
};

class wf {
    $;
    Be;
    constructor(t, n) {
        this.$ = t;
        this.Be = n;
    }
    get(t, n, e) {
        if (n === $f) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Be.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Be[o];
        const i = this.Be[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Mc(c);
        try {
            const e = xc(c, r, i);
            Reflect.set(t, n, e);
            this.Be[o] = 0;
            this.Be[o + 1] = e;
            df(r) && ((t, n, e, s) => {
                const o = Mc(t);
                try {
                    const o = ce(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    Ic(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            Ic(c, l);
        }
    }
    has(t, n) {
        if (n === $f) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === $f) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Be.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Be[i] = 0;
        this.Be[i + 1] = e;
        return !0;
    }
}

const mf = t => {
    if (!t.He) {
        t.He = !0;
        t.Qe();
    }
};

const bf = (t, n, e) => {
    const s = {
        Je: t,
        Qe: void 0,
        He: !1
    };
    const o = gi(() => {
        ((t, n, e) => {
            t.He = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Je.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        mf(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.$n?.();
            n(t);
        }, t => {
            o.$n?.();
            e(t);
        });
    });
    s.Qe = o;
    return s;
};

async function de(t) {
    const n = _c(null, null, () => "", () => {}, new WeakMap);
    n.Rt(t);
    await n.Jt();
    return n.Yt.toString();
}

async function pe(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = we(n, () => e);
    s.Gt = e;
    await vf(le(s, n, e));
    return e[0];
}

const vf = t => new Promise((n, e) => {
    const s = bf(t, n, e);
    mf(s);
});

function $e(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ye(t) {
    let n;
    const e = we(t, () => n);
    n = yf(e, t);
    e.Gt = n;
    return e;
}

function we(t, n) {
    const e = {
        k: t => $e(t, n()),
        Zt: t => e.Tt?.[+t],
        getSyncFn: () => () => {},
        yt: new WeakMap,
        element: null,
        Tt: null
    };
    Dn(t, e);
    return e;
}

const _f = (t, n) => {
    const e = new WeakSet;
    return ca(gf, t, e, "_", n);
};

const gf = (t, n, e, s) => {
    const o = tc(t);
    if (o == null) {
        return t;
    }
    if (Sf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Fu(o)) {
            return t;
        }
        if (Ec(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (si(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (tr(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw rr(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw rr(3, [ o ]);
                    }
                    gf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof os) {
                return t;
            }
            if (Ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    gf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw rr(3, [ i ]);
    }
    return t;
};

const Ef = /*#__PURE__*/ new WeakSet;

const Sf = t => {
    if (Ke(t) || er(t)) {
        return !Ef.has(t) && !(Pf in t);
    }
    return !0;
};

const kf = t => !!t && (Ke(t) || typeof t === "function") && (Ef.has(t) || Pf in t);

const Rf = t => {
    (Ke(t) && t !== null || typeof t === "function") && Ef.add(t);
    return t;
};

const Pf = Symbol();

const Tf = Symbol();

const Af = t => /*#__PURE__*/ Object.freeze({
    id: pi(t)
});

const qf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const Mf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(Oe(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw rr(8, [ t.id ]);
};

const If = t => {
    const n = oa();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const xf = /*#__PURE__*/ Af("qk-error");

const Nf = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const Cf = "An error occurred";

const Of = t => wi(Nf(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const jf = /*#__PURE__*/ Symbol();

const Lf = t => {
    const n = Error(Cf);
    n.digest = Of(t);
    Object.defineProperty(n, jf, {
        value: !0
    });
    return n;
};

const Ff = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = Cf;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Xf = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => Nf(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : Lf(t);
            }
            if (s != null) {
                n && si(s);
                return Lf(t);
            }
        }
        if (Nf(() => t instanceof Error && jf in t, !1)) {
            return t;
        }
        if (!n) {
            return Lf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return Ff(t);
    } catch {
        return Lf(t);
    }
};

const Df = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = Of(n);
        Promise.resolve(t(Ff(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(Be);
    } catch (t) {
        Be(t);
    }
};

const Wf = /*#__PURE__*/ new WeakSet;

const Vf = t => {
    Wf.add(t);
};

const Uf = /*#__PURE__*/ Symbol();

const zf = (t, n) => {
    try {
        Object.defineProperty(t, Uf, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Bf = (t, n, e = "render") => {
    t.error = n ?? Ff(n);
    const s = t.Ye;
    s && Df(s, n, (t => Nf(() => t?.[Uf], void 0))(n) ?? e, t.boundaryId ?? "");
};

const Hf = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(jr)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        Be(t);
    }
};

function me(t, n) {
    const e = t.getHostProp(n, Rr);
    return e ? Ye(e, xf.id, 0) : null;
}

const Dd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Wd = new WeakMap;

class Vd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Ud(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Dd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Ud = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const zd = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = sa()?.$;
    return t?.outOfOrderStreaming === !0 && !jd(t);
};

const Qf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Uu(t, n, r);
};

const Jf = new WeakMap;

function* be(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Kt}"]${br}`);
    const o = Yf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(vr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* ve(t, e, i.textContent);
        yield;
    }
}

const Yf = t => {
    let n = Jf.get(t);
    if (!n) {
        n = new WeakSet;
        Jf.set(t, n);
    }
    return n;
};

function* ve(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.tn.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.tn[e * 2 + t] = s[t];
            yield;
        }
        yield* Wn(n.tn, t, e * 2);
        n.nn = yf(t, n.tn);
        n.nn.length = n.tn.length / 2;
        n.en = n.Tt;
    }(t, n, s, o);
    Gf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const r = s.subscriptions;
            if (o instanceof Xs) {
                r instanceof Set && Qf(t, o, o, o.ht ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Yu(o);
                const e = Gu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ht ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    Qf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.k(i));
}

const Gf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.en ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Tt = e;
};

const Zf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function _e(t, n) {
    const e = t.qVNodeDataState ||= {
        rn: [],
        sn: null
    };
    t.qProcessVNodeDataPatch ||= n => _e(t, Se(t, n));
    t.qVNodeDataReady = !1;
    e.rn.push(n);
    ge(t, e);
}

function ge(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Ee(t);
        return;
    }
    n.sn = bf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.sn = null;
            ge(t, n);
        }
    }, e => {
        n.sn = null;
        Be(e);
        Ee(t);
    });
    mf(n.sn);
}

function Ee(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* Se(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* ke(t, s || void 0, e, o, n.textContent));
}

function* ke(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Kf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                yield* v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                yield* v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* v(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (m === 126) {
                            g = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = ta(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? ar(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== fr || n.charCodeAt(1) !== fr || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* E(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* m(t);
    const S = t.createTreeWalker(t, 129);
    yield* v(S, null, S.firstChild(), null, "", null, null);
}

const Kf = t => 33 <= t && t <= 46;

const ta = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Kf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Re(t) {
    return t.ln === 3;
}

function Pe(t, n) {
    const e = t.un ||= {
        rn: [],
        sn: null
    };
    t.ln = 2;
    e.rn.push(n);
    Te(t, e);
}

const na = (t, n) => {
    const e = t;
    if (Re(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Re(e)) {
                    (e.cn ||= []).push(s);
                    return;
                }
                Zf(e.document, () => {
                    Re(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Te(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Ae(t);
        return;
    }
    n.sn = bf(e, () => {
        n.sn = null;
        Te(t, n);
    }, e => {
        n.sn = null;
        Be(e);
        Ae(t);
    });
    mf(n.sn);
}

function Ae(t) {
    const n = t.ln;
    if (n !== 2) {
        return;
    }
    t.ln = 3;
    t.un = void 0;
    const e = t.cn;
    t.cn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function qe(t) {
    const n = Ie(t);
    if (!n) {
        throw rr(24);
    }
    return Me(n);
}

function Me(t) {
    const n = t;
    return n.qContainer ||= new ea(n);
}

function Ie(t) {
    return t.closest(jr);
}

function xe(t, n) {
    const e = t + "";
    const s = n?.closest(jr);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            _e(t, function* i(t, n, e, s, o, r) {
                yield* ke(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* Se(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Zf(t, () => {
            o.element.qContainer === o && Pe(o, be(o, e));
        });
    }
}

class ea extends zc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    yt=new WeakMap;
    Ge;
    Kt;
    Tt=null;
    vNodeLocate=t => Fl(this.rootVNode, t);
    ln=0;
    cn=void 0;
    un=void 0;
    tn;
    nn;
    en=null;
    Ze=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Nr);
        if (!this.qContainer) {
            throw rr(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.ze = t.getAttribute(Ar);
        this.Kt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = _l(this.element);
        this.tn = [];
        this.nn = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= xe);
        this.Ge = Tr(n, this.Kt) || Ss;
        this.Ke();
        t.qContainer = this;
        t.qDestroy = () => this.$n();
        __EXPERIMENTAL__.errorBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = Hf;
                t.addEventListener?.("qerror", Hf);
            }
        }(this.document);
        this.ln = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            _e(e, function* s(t) {
                yield* ke(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Zf(n, () => {
            this.ln === 1 && Pe(this, this.tr());
        });
    }
    * tr() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Kt}"]:not(${br})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${br})`);
        if (n) {
            this.tn = JSON.parse(n.textContent);
            yield* Wn(this.tn, this);
            this.en = this.Tt;
            const e = this.tn.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.nn = s !== null && e > 0 && e >= +s ? yield* le(this, this.tn) : yf(this, this.tn);
        }
        __EXPERIMENTAL__.suspense && (yield* be(this));
        this.nr();
        t.setAttribute(Nr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    $n() {
        this.vNodeLocate = () => null;
        this.tn.length = 0;
        this.nn.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Nr);
        const n = t.ownerDocument;
        this.un = void 0;
        this.ln = 0;
        const e = n.querySelector(jr) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    nr() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Sr);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Yn(t, n) {
        this.nn[t] = n;
    }
    parseQRL(t) {
        return Fn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.errorBoundary) {
            const e = n && this.resolveContext(n, xf);
            if (!e) {
                throw t;
            }
            e.error = t;
            return;
        }
        const s = t ?? Ff(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, xf);
            if (!n) {
                break;
            }
            const r = me(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, Ur);
                Df(o?.onError$, t, e, r.boundaryId ?? "");
                wn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                Be(t);
                return;
            }
            o = this.getParentHost(n);
        }
        ((t, ...n) => {
            He(!0, t, ...n);
        })(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Rr);
        s == null && this.setHostProp(t, Rr, s = []);
        Je(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? Ye(this.getHostProp(e, Rr), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Rr);
            if (e != null && Ge(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Al(n)) {
                if (Ml(n, hr, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Il(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case zr:
          case Ur:
          case hr:
          case Rr:
          case Pr:
            s = this.k;
            break;

          case Br:
          case Gr:
            s = parseInt;
            break;
        }
        return Ml(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => $e(t, this.nn);
    Zt(t) {
        return this.en?.[t];
    }
    getSyncFn(t) {
        const n = this.Ge[t];
        return n;
    }
    er(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, kr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, kr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ze == null) {
            this.Ze = new Set;
            const t = this.document.querySelectorAll(Er);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ze.add(e.getAttribute(gr));
            }
        }
        if (!this.Ze.has(n)) {
            this.Ze.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(gr, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ke() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === ni) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.pn = {
            containerAttributes: t
        };
    }
}

let ra;

let Bd;

if (We) {
    const t = Vc();
    t && (Bd = new t);
}

function Ne(t) {
    if (Bd) {
        const t = Bd.getStore();
        if (t) {
            return t;
        }
    }
    if (ra === void 0) {
        const n = sa();
        if (n && n.fn) {
            return n.fn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return ra;
}

function Ce(t, n) {
    if (Bd) {
        return Bd.run(t, n);
    }
    const e = ra;
    try {
        ra = t;
        return n();
    } finally {
        ra = e;
    }
}

let ia;

const sa = () => ia;

const oa = () => {
    const t = sa();
    if (!t) {
        throw rr(9);
    }
    return t;
};

const la = () => {
    const t = sa();
    if (!t || t.an !== Dr) {
        throw rr(10);
    }
    return t;
};

function Oe(t, n, ...e) {
    return je.call(this, t, n, e);
}

function je(t, n, e) {
    const s = ia;
    try {
        ia = t;
        return n.apply(this, e);
    } finally {
        ia = s;
    }
}

const ua = (t, n, e = qe(n)) => {
    const s = Fl(e.rootVNode, n);
    const o = e.fn;
    o && function r(t) {
        if (Bd) {
            Bd.enterWith(t);
            return;
        }
        ra = t;
    }(o);
    const i = Fe(o, s, t);
    i.$ = e;
    return i;
};

function Le(t, n, e) {
    const s = {
        _: n,
        an: Dr,
        hn: void 0,
        fn: t,
        $: e,
        dn: void 0
    };
    return s;
}

function Fe(t, n, e) {
    const s = t || (e && Ke(e) && "locale" in e ? e.locale : void 0);
    const o = {
        _: n,
        an: e,
        hn: void 0,
        fn: s,
        $: void 0
    };
    return o;
}

const ca = (t, ...n) => {
    if (typeof t === "function") {
        if (!ia) {
            return t(...n);
        }
        {
            const e = ia.hn;
            try {
                ia.hn = void 0;
                return t(...n);
            } finally {
                ia.hn = e;
            }
        }
    }
    if (Fu(t)) {
        return t.untrackedValue;
    }
    return tc(t);
};

const fa = /*#__PURE__*/ Le(void 0, void 0, void 0);

const aa = (t, n, e, s, o) => {
    const r = fa.hn;
    const i = fa.$;
    try {
        fa.hn = m(n, e, o);
        fa.$ = s;
        return je(fa, t);
    } finally {
        fa.hn = r;
        fa.$ = i;
    }
};

const ha = (t, n, e, s, o) => {
    t instanceof so && t._ !== n && n && (t._ = n);
    return aa(() => t.value, n, e, s, o);
};

const da = () => sa()?._;

const pa = () => {
    const t = sa();
    if (t) {
        return t.an;
    }
};

const $a = () => {
    const t = sa();
    if (t) {
        return t.$;
    }
};

const ya = t => t;

const wa = t => t.l || Promise.resolve();

let ma;

let ba = (t, n, e, s, o) => new va(t, n, e, s, o);

class va {
    Et;
    gt;
    rr;
    ir;
    $;
    constructor(t, n, e, s, o) {
        this.Et = t;
        this.gt = n;
        this.rr = e;
        this.ir = s;
        s && this.sr(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Ve && t && De(t, .8);
    }
    get ot() {
        return Nd(this.gt);
    }
    sr(t) {
        this.ir = t;
        si(t) && t.then(t => this.ir = t, t => {
            const n = `qrl ${this.gt} failed to load`;
            if (We) {
                console.error(n, t);
            } else if (Ve) {
                const e = this.Et === null ? "symbol:" + this.gt : "chunk:" + this.Et;
                const s = this.$;
                let o = s && ma?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (ma ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.ir = null;
        });
    }
    lr() {
        if (this.ir != null) {
            return this.ir;
        }
        if (this.Et === "") {
            const t = this.$.Kt;
            const n = this.$.element?.ownerDocument || document;
            const e = Tr(n, t);
            return this.ir = e[+this.gt];
        }
        Ve && this.Et && De(this.Et, 1);
        const t = this.gt;
        const n = this.rr ? this.rr().then(n => n[t]) : Pi().importSymbol(this.$?.element, this.Et, t);
        this.sr(n);
        return this.ir;
    }
}

Ve && import.meta.hot && (t => {
    if (!Ve || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        ba = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.Et;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.Et;
            if (i) {
                t.Et = e(i, o);
                r = !0;
            }
            const c = t.rr?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.rr = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.gt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.gt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ir = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(va);

const _a = Symbol();

const ga = t => t?.[_a] ?? t;

class Ea {
    ur;
    resolved=void 0;
    Ot;
    $;
    constructor(t, n, e) {
        this.ur = t;
        if (n) {
            this.Ot = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ir == null || this.Ot && typeof this.Ot === "string" || si(t.ir) || (this.resolved = Ma(this, t.ir));
    }
}

const Sa = function(t, ...n) {
    const e = ga(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = sa();
    return ka.call(e, s?.$).then(() => je.call(t, s, e.resolved, n));
};

const ka = async function(t) {
    const n = ga(this);
    return li(Ia(n, t), () => n.resolved);
};

const Ra = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[_a].resolved;
        },
        set(t) {
            this[_a].resolved = t;
        }
    },
    Ot: {
        get() {
            return this[_a].Ot;
        },
        set(t) {
            this[_a].Ot = t;
        }
    },
    jt: {
        get() {
            return this[_a].ur.jt;
        }
    },
    $: {
        get() {
            return this[_a].$;
        },
        set(t) {
            this[_a].$ = t;
        }
    },
    ur: {
        get() {
            return this[_a].ur;
        }
    },
    Et: {
        get() {
            return this[_a].ur.Et;
        }
    },
    gt: {
        get() {
            return this[_a].ur.gt;
        }
    },
    ot: {
        get() {
            return this[_a].ur.ot;
        }
    },
    dev: {
        get() {
            return this[_a].ur.dev;
        }
    },
    cr: {
        value: Sa
    },
    w: {
        value: function(t) {
            const n = ga(this);
            const e = new Ea(n.ur, t, n.Ot ? n.$ : void 0);
            return Na(e);
        }
    },
    m: {
        value: function() {
            this[_a].ur.jt = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = ga(this);
            n.ur.sr(t);
            n.resolved = Ma(n, t);
        }
    },
    resolve: {
        value: ka
    },
    getSymbol: {
        value: function() {
            return ga(this).ur.gt;
        }
    },
    getHash: {
        value: function() {
            return ga(this).ur.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = ga(this);
            qa(t);
            return t.Ot;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = ga(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return ka.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return je(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Pa = null;

const Ta = t => {
    Pa = t;
};

const Aa = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.k(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const qa = t => {
    const n = t.Ot;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw rr(13);
        }
        const s = ff;
        Pa = t.Ot = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Aa(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Aa(t, n, s + 1, o);
        })(e, n);
        if (ff !== s) {
            return ff;
        }
    } else {
        Pa = n || null;
    }
};

const Ma = (t, n) => {
    if (typeof n !== "function" || !t.Ot) {
        return n;
    }
    return function e(...s) {
        qa(t);
        return n.apply(this, s);
    };
};

const Ia = (t, n) => {
    const e = t.ur;
    const s = typeof t.Ot === "string";
    s && !t.$ && (t.$ = n || sa()?.$);
    if (t.resolved) {
        return;
    }
    const o = La();
    const r = sa();
    const i = e.lr();
    const c = li(i, n => {
        t.resolved = Ma(t, n);
    });
    if (c) {
        const t = e.gt;
        Oa(t, r?._ instanceof us ? r?._.node : void 0, o);
    }
    const l = s && t.$ && qa(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const xa = (t, n, e, s, o, r) => {
    const i = ba(t, n, s, e, r);
    const c = new Ea(i, o, r);
    return Na(c);
};

const Na = t => {
    const n = async function(...t) {
        return Sa.call(n, this, ...t);
    };
    n[_a] = t;
    Object.setPrototypeOf(n, Ra);
    return n;
};

const Ca = /*#__PURE__*/ new Set;

const Oa = (t, n, e) => {
    if (!Ca.has(t)) {
        Ca.add(t);
        ja("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const ja = (t, n) => {
    Cd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const La = () => {
    if (Cd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Fa = 0;

const Xa = t => xa(null, "s" + Fa++, t, null, null);

const Da = Xa;

const Wa = t => t;

const Va = t => xa("", ir, t, null, null);

const Ua = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return xa("", ir, t, null, null);
};

const za = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Ba] = [ t ];
        return _o(i, n, null, n.children, s, r);
    }
    n[Ba] = [ t ];
    return n;
};

const Ba = Symbol();

const Ha = t => typeof t == "function" && t[Ba] !== void 0;

const Qa = t => za(Da(t));

const Ja = Vs(Wa);

const Ya = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Ga = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Zi(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Nr, "resumed");
    const s = qe(t);
    s.pn = e.serverData || {};
    const o = s.rootVNode;
    Il(o, ps, n);
    wn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            St(s, [], s.rootVNode);
        }
    };
};

const Za = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e != null) {
        return e;
    }
    const r = er(t) ? Oe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = ec(r, i, t);
        s(c);
        return c;
    }
};

const Ka = t => {
    const n = Ki(t);
    return (t => t.toString(36))(n.Ue++);
};

const th = () => {
    const {val: t, set: n, iCtx: e} = Ko();
    if (t != null) {
        return t;
    }
    const s = e.$.ze || "";
    const o = s ? wi(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e._, hr);
    const i = r?.getHash().substring(0, 3) || "";
    const c = Ka(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Xe(t, n) {
    const e = sa();
    return e?.$?.pn[t] ?? n;
}

const nh = /*#__PURE__*/ new Map;

const eh = (t, n) => {
    let e = nh.get(n);
    e || nh.set(n, e = rh(t, n));
    return e;
};

const rh = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = uh;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Ch) {
            r++;
            e = Ih;
        }
        const s = Vh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === wh || $ === mh && ih(l) || $ === vh && lh(l)) && (y === e || y === wh || y === mh && ih(e) || y === bh && !ih(e) && e !== Th || y === vh && lh(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (w === $h || w == yh) {
                    if (w === yh) {
                        if (c !== ch || h()) {
                            if (!sh(e)) {
                                const t = y == bh ? 1 : y == Rh ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            sh(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === bh) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || uh;
                        if (c === fh) {
                            u(r - 1);
                            i++;
                        }
                    } while (oh(c));
                } else {
                    o.push(c);
                    if (c === fh && w === uh) {
                        u(r - 8);
                        i = r;
                    } else {
                        w === ah && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === fh || h()) {
            return;
        }
        u(t);
        s.push(".", $r, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ph) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ph) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | jh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(fh) !== -1 || o.indexOf(hh) !== -1;
    }
};

const ih = t => t >= Ah && t <= qh || t >= Ih && t <= xh || t >= Lh && t <= Fh || t >= 128 || t === Oh || t === Ph;

const sh = t => t === Mh || t === Th || t === Nh || t === kh || ih(t);

const oh = t => t === dh || t === hh || t === ph || t === fh;

const lh = t => t === Sh || t === _h || t === gh || t === Eh;

const uh = 0;

const ch = 2;

const fh = 5;

const ah = 6;

const hh = 10;

const dh = 11;

const ph = 12;

const $h = 17;

const yh = 18;

const wh = 0;

const mh = 1;

const bh = 2;

const vh = 3;

const _h = 9;

const gh = 10;

const Eh = 13;

const Sh = 32;

const kh = 35;

const Rh = 41;

const Ph = 45;

const Th = 46;

const Ah = 48;

const qh = 57;

const Mh = 58;

const Ih = 65;

const xh = 90;

const Nh = 91;

const Ch = 92;

const Oh = 95;

const jh = 32;

const Lh = 97;

const Fh = 122;

const Xh = 123;

const Dh = 125;

const Wh = /*@__PURE__*/ (() => [ [ wh, 39, 14 ], [ wh, 34, 15 ], [ wh, 47, 16, "*" ] ])();

const Vh = /*@__PURE__*/ (() => [ [ [ wh, 42, ch ], [ wh, Nh, 7 ], [ wh, Mh, ah, ":", "before", "after", "first-letter", "first-line" ], [ wh, Mh, fh, "global" ], [ wh, Mh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ wh, Mh, 4 ], [ wh, mh, 1 ], [ wh, Th, 1 ], [ wh, kh, 1 ], [ wh, 64, hh, "keyframe" ], [ wh, 64, dh, "media", "supports", "container" ], [ wh, 64, ph ], [ wh, Xh, 13 ], [ 47, 42, 16 ], [ wh, 59, $h ], [ wh, Dh, $h ], [ wh, Rh, $h ], ...Wh ], [ [ wh, bh, yh ] ], [ [ wh, bh, yh ] ], [ [ wh, 40, uh ], [ wh, bh, yh ] ], [ [ wh, 40, 8 ], [ wh, bh, yh ] ], [ [ wh, 40, uh ], [ wh, bh, $h ] ], [ [ wh, bh, $h ] ], [ [ wh, 93, yh ], [ wh, 39, 14 ], [ wh, 34, 15 ] ], [ [ wh, Rh, $h ], ...Wh ], [ [ wh, Dh, $h ], ...Wh ], [ [ wh, Dh, $h ], [ vh, mh, 1 ], [ wh, Mh, fh, "global" ], [ wh, Xh, 13 ], ...Wh ], [ [ wh, Xh, uh ], [ wh, 59, $h ], ...Wh ], [ [ wh, 59, $h ], [ wh, Xh, 9 ], ...Wh ], [ [ wh, Dh, $h ], [ wh, Xh, 13 ], [ wh, 40, 8 ], ...Wh ], [ [ wh, 39, $h ] ], [ [ wh, 34, $h ] ], [ [ 42, 47, $h ] ] ])();

const Uh = t => ({
    styleId: Qh(t, t => t, !1)
});

const zh = /*#__PURE__*/ Vs(Uh);

const Bh = t => ({
    scopeId: $r + Qh(t, eh, !0)
});

const Hh = /*#__PURE__*/ Vs(Bh);

const Qh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Ko();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${wi(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.er(n(t, c), c, l, e));
    }
    r.$.er(n(t.resolved, c), c, l, e);
    return c;
};

const Jh = (t, n) => {
    t.resolve();
    return Hs(t, n);
};

const Yh = (t, n) => el(Jh, t, n);

const Gh = Vs(Yh);

const Zh = t => {
    t.resolve();
    return Js(t);
};

const Kh = t => el(Zh, t);

const td = Vs(Kh);

const nd = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Ko();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Cd()) {
            e.h |= 32;
            ed(e, i);
        }
        return;
    }
    let c;
    if (Cd()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        wn(r.$, r._, 1);
    }
    const l = new Ou(c, o, r._, t, null);
    s(l);
    ed(l, i);
};

const ed = (t, n) => {
    n === "intersection-observer" ? ef("qvisible", rd(t)) : n === "document-ready" ? rf("qinit", rd(t)) : n === "document-idle" && rf("qidle", rd(t));
};

const rd = t => xa(null, "_task", Mn, null, [ t ]);

const id = Vs(Kc);

const sd = /*#__PURE__*/ Vs(Nu);

const od = /*#__PURE__*/ Vs(nd);

const ld = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Hd(t, n, e, s) {
    const o = n + "";
    const r = await e.container.S(o, e);
    t.write(`<template ${vr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.P;
    if (__EXPERIMENTAL__.errorBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const ud = () => {
    const [t] = Pa;
    const n = sa()?.$;
    const e = Ve;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, xf);
        if (!e) {
            return;
        }
        const s = me(t, e);
        if (!s) {
            return;
        }
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = Ru(n);
            let i = !1;
            for (;r; ) {
                if (Al(r)) {
                    if (Ml(r, yr, null) !== null) {
                        i = !0;
                    } else if (Ml(r, hr, null) !== null) {
                        if (!i) {
                            const n = me(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = Ru(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${cd}`;
                wn(t, o, 4);
            } else {
                wn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const cd = "\0";

const fd = t => {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw Error('<ErrorBoundary> requires the `errorBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["errorBoundary"] }).');
    }
    const n = (() => {
        const t = Za(ld);
        qf(xf, t);
        return t;
    })();
    const e = sa();
    const s = e?.$;
    s && (Gu(n) ?? n).boundaryId === void 0 && (n.boundaryId = Ka(s));
    const o = !Ve;
    if (!o && n.error === void 0) {
        return /* @__PURE__ */ vo(Mo, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Cc(ud, "_ebR", [ e?._ ]);
    if (o) {
        const e = t.fallback$;
        n.Mt = Rf(t => e(t, r));
        const o = t.onError$;
        o && (n.Ye = Rf((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ vo("div", {
                [_r]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ vo(Mo, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ vo(Yd, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Xf(n.error, !0);
    return /* @__PURE__ */ vo(Ao, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        return /* @__PURE__ */ vo("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const ad = 
/*#__PURE__*/ za(
/*#__PURE__*/ Cc(fd, "_ebC"));

const Qd = (t, n) => {
    const e = n.Mt;
    delete n.Mt;
    const s = Xf(n.error, Ue, t.I);
    return e(s);
};

const Jd = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Xd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.Mt) {
                return;
            }
            r.error !== n && Bf(r, n, "render");
            const s = await t.segment("" + o, Qd(t, r), e);
            s.container.A(o);
            await t.C(() => Hd(t, o, s, null));
        };
        r.xt = Rf(n);
        t.write(`<template ${vr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.Mt) {
        return;
    }
    jd(t) ? t.A(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(Qd(t, r));
}) : null;

const Yd = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Xd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.suspense && t.outOfOrderStreaming && !jd(t) && (r.error === void 0 || (t => Wf.has(t))(r));
    s(
    /*#__PURE__*/ vo("div", {
        [i ? xd : "q:ebf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ vo(Jd, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
}) : null;

const hd = async ({track: t}) => {
    const n = Pa[0];
    t(() => n.items);
    const e = sa();
    const s = e._;
    const o = e.$;
    const r = wn(o, s, 256);
    const i = We;
    i && await r;
};

const dd = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Nu(/*#__PURE__*/ Cc(hd, "_eaT", [ t ]));
    return Io;
};

const pd = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(dd, "_eaC"));

const $d = (t, n, e) => sr(t) ? t.getFn(n)(e) : t(e);

const yd = ({track: t}) => {
    const n = Pa[0];
    const e = sa();
    const s = e._;
    const o = e.$;
    const r = We;
    return li(t(() => $d(n.when$, sa(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return li(i ? $d(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            zt(s, n);
            wn(o, s, 2);
        });
    });
};

const wd = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Nu(/*#__PURE__*/ Cc(yd, "_shT", [ t ]));
    return Io;
};

const md = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(wd, "_shC"));

const bd = /*#__PURE__*/ Af("qk-reveal");

const vd = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ys(0)
});

const _d = () => {
    const t = Pa[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Ve) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Dd(t);
};

const gd = ({cleanup: t}) => {
    const n = Pa[0];
    t(() => {
        if (!Ve) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Ed = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = el(vd, t);
    qf(bd, n);
    const e = !Ve;
    if (__EXPERIMENTAL__.suspense && e && zd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = sa().$;
                const s = (Wd.get(e) || 0) + 1;
                Wd.set(e, s);
                return new Vd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Rf(e);
            return e;
        })(n);
        return /* @__PURE__ */ vo(Gd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ vo(Mo, null, null, null, 0, "u7_0");
};

const Sd = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(Ed, "_reC"));

const Gd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Xd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ vo(Mo, null, null, null, 0, "u7_0"));
}) : null;

const kd = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Zd = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Rd = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const Pd = ({track: t, cleanup: n}) => {
    const e = Pa[0], s = Pa[1], o = Pa[2], r = Pa[3];
    const i = t(e);
    const c = Ve;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Td = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = nl("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return nl(0);
    })();
    const s = (t => {
        const n = Mf(bd, null);
        const e = el(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Nu(/*#__PURE__*/ Cc(gd, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Yh(
    /*#__PURE__*/ Cc(_d, "_reR", [ s ]));
    Nu(
    /*#__PURE__*/ Cc(Pd, "_suT", [ e, t, n, s ]));
    const r = !Ve;
    const i = r && zd();
    const c = i ? (() => sa().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && ca(() => t.fallback != null && t.fallback !== !1) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Uc(Rd, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = i ? /*#__PURE__*/ vo(Kd, {
        boundary: f,
        fallbackStyle: Uc(kd, [ t, n, o, s ], Zd),
        showFallback: u,
        state: n
    }, null, eo(t, "fallback"), 1, null) : /*#__PURE__*/ vo("div", {
        style: Uc(kd, [ t, n, o, s ], Zd)
    }, null, eo(t, "fallback"), 1, null);
    return [ d, 
    /*#__PURE__*/ vo("div", null, i ? {
        [xd]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ vo(i ? tp : Mo, i ? {
        [Kr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Kr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Ad = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(Td, "_suC"));

const Kd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Xd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.C(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ vo("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const tp = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Xd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.errorBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, xf) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ vo(Mo, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ vo(Mo, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${vr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.C(async () => {
            t.addRoot(o);
            await Hd(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.xt) {
            return l.xt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
}) : null;

const qd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Md.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return vo("script", null, o, null, 0, "prefetch-service-worker");
};

const Md =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Id = () => null;

globalThis.__qwik && rr(30, [ globalThis.__qwik, Gi ]);

globalThis.__qwik = Gi;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Xa as $, pd as Each, ad as ErrorBoundary, Ao as Fragment, Pf as NoSerializeSymbol, Id as PrefetchGraph, qd as PrefetchServiceWorker, qo as RenderOnce, tf as Resource, Sd as Reveal, No as SSRComment, xo as SSRRaw, Oo as SSRStream, Co as SSRStreamBlock, Tf as SerializerSymbol, md as Show, Io as SkipRender, Mo as Slot, Ad as Suspense, ms as _CONST_PROPS, ea as _DomContainer, ts as _EFFECT_BACK_REF, zr as _ELEMENT_SEQ, Ss as _EMPTY_ARRAY, ks as _EMPTY_OBJ, gs as _IMMUTABLE, zc as _SharedContainer, oo as _SubscriptionData, uc as _SubscriptionPatch, Ou as _Task, Es as _UNINITIALIZED, bs as _VAR_PROPS, ee as _addProjection, Pa as _captures, v as _chk, ye as _createDeserializeContainer, xa as _createQRL, xn as _createStore, ui as _delay, pe as _deserialize, Rc as _dumpState, dd as _eaC, hd as _eaT, fd as _ebC, ud as _ebR, $n as _executeSsrChores, Uc as _fnSignal, Vc as _getAsyncLocalStorage, Is as _getConstProps, $a as _getContextContainer, pa as _getContextEvent, da as _getContextHostElement, qe as _getDomContainer, Ie as _getQContainerElement, m as _getSubscriber, Ms as _getVarProps, Jn as _handleSSRError, Ku as _hasStoreEffects, uf as _hmr, Bs as _injectAsyncSignalValue, Oe as _invoke, co as _isJSXNode, nc as _isStore, Un as _isStringifiable, ju as _isTask, ya as _jsxBranch, go as _jsxC, So as _jsxQ, Eo as _jsxS, vo as _jsxSorted, _o as _jsxSplit, Qe as _mapApp_findIndx, Ye as _mapArray_get, Je as _mapArray_set, Hu as _markSignalAsExternallyOwned, Fe as _newInvokeContext, Oc as _noopQrl, jc as _noopQrlDEV, Dn as _preprocessState, Ua as _qrlSync, jn as _qrlToString, Lc as _qrlWithChunk, Fc as _qrlWithChunkDEV, Ed as _reC, _d as _reR, gd as _reT, Wc as _regSymbol, se as _removeProjection, _ as _res, If as _resolveContextWithoutSequentialScope, Wo as _restProps, n as _retryOnPromise, Zc as _rsc, N as _run, de as _serialize, Kn as _setEvent, re as _setProjectionTarget, wd as _shC, yd as _shT, Td as _suC, Pd as _suT, Mn as _task, ie as _updateProjectionProps, ne as _useHmr, b as _val, _f as _verifySerializable, Cl as _vnode_ensureElementInflated, Su as _vnode_getAttrKeys, ru as _vnode_getElementName, ou as _vnode_getFirstChild, Ml as _vnode_getProp, Wl as _vnode_getVNodeForChildNode, Zl as _vnode_insertBefore, kl as _vnode_isElementVNode, Pl as _vnode_isMaterialized, Tl as _vnode_isTextVNode, Al as _vnode_isVirtualVNode, El as _vnode_newVirtual, nu as _vnode_remove, Il as _vnode_setProp, Sn as _vnode_toString, wa as _waitUntilRendered, Bn as _walkJSX, eo as _wrapProp, io as _wrapSignal, Qa as component$, za as componentQrl, Qs as createAsyncQrl, Gs as createComputed$, Hs as createComputedQrl, Af as createContextId, g as createElement, Zs as createSerializer$, Js as createSerializerQrl, Ys as createSignal, Ja as event$, Wa as eventQrl, Zu as forceStoreEffects, Ya as getClientManifest, qe as getDomContainer, Ne as getLocale, Pi as getPlatform, g as h, Vs as implicit$FirstArg, Cc as inlinedQrl, Dc as inlinedQrlDEV, Ue as isDev, Fu as isSignal, Ro as jsx, Po as jsxDEV, To as jsxs, Rf as noSerialize, Nc as qrl, Xc as qrlDEV, Ga as render, Ri as setPlatform, Va as sync$, ca as untrack, tc as unwrapStore, Gh as useComputed$, Yh as useComputedQrl, el as useConstant, Mf as useContext, qf as useContextProvider, th as useId, Gc as useLexicalScope, ef as useOn, rf as useOnDocument, sf as useOnWindow, id as useResource$, Kc as useResourceQrl, td as useSerializer$, Kh as useSerializerQrl, Xe as useServerData, nl as useSignal, Za as useStore, zh as useStyles$, Uh as useStylesQrl, Hh as useStylesScoped$, Bh as useStylesScopedQrl, sd as useTask$, Nu as useTaskQrl, od as useVisibleTask$, nd as useVisibleTaskQrl, Gi as version, Ce as withLocale };
